(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };
},{"core-js/library/fn/object/define-property":6}],2:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };
},{"core-js/library/fn/object/keys":7}],3:[function(require,module,exports){
"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
},{}],4:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
},{"../core-js/object/define-property":1}],5:[function(require,module,exports){
//
// **Bugsnag.js** is the official JavaScript notifier for
// [Bugsnag](https://bugsnag.com).
//
// Bugsnag gives you instant notification of errors and
// exceptions in your website's JavaScript code.
//
// Bugsnag.js is incredibly small, and has no external dependencies (not even
// jQuery!) so you can safely use it on any website.
//

// The `Bugsnag` object is the only globally exported variable
(function (window, old) {
  var self = {},
    lastEvent,
    lastScript,
    previousNotification,
    shouldCatch = true,
    ignoreOnError = 0,

    // We've seen cases where individual clients can infinite loop sending us errors
    // (in some cases 10,000+ errors per page). This limit is at the point where
    // you've probably learned everything useful there is to debug the problem,
    // and we're happy to under-estimate the count to save the client (and Bugsnag's) resources.
    eventsRemaining = 10,
    // The default depth of attached metadata which is parsed before truncation. It
    // is configurable via the `maxDepth` setting.
    maxPayloadDepth = 5;

  // #### Bugsnag.noConflict
  //
  // This is obsolete with UMD, as we cannot assume the global scope is polluted with
  // the Bugsnag object anyway. In this case, it's up to the host Javascript file to
  // correctly utilise this functionality.
  //
  // Maybe it's worth removing all together, if we're loading via any UMD method.
  self.noConflict = function() {
    window.Bugsnag = old;
    if (typeof old === "undefined") {
      delete window.Bugsnag;
    }
    return self;
  };

  // ### Bugsnag.refresh
  //
  // Resets the Bugsnag rate limit. If you have a large single-page app, you may
  // wish to call this in your router to avoid exception reports being thrown
  // away.
  //
  // By default Bugsnag aggressively limits the number of exception reports from
  // one page load. This protects both the client's browser and our servers in
  // cases where exceptions are thrown in tight loops or scroll handlers.
  self.refresh = function() {
    eventsRemaining = 10;
  };

  //
  // ### Manual error notification (public methods)
  //

  // #### Bugsnag.notifyException
  //
  // Notify Bugsnag about a given `exception`, typically that you've caught
  // with a `try/catch` statement or that you've generated yourself.
  //
  // It's almost always better to let an exception bubble rather than catching
  // it, as that gives more consistent behaviour across browsers. Consider
  // re-throwing instead of calling .notifyException.
  //
  // Since most JavaScript exceptions use the `Error` class, we also allow
  // you to provide a custom error name when calling `notifyException`.
  //
  // The default value is "warning" and "error" and "info" are also supported by the
  // backend, all other values cause the notification to be dropped; and you
  // will not see it in your dashboard.
  self.notifyException = function (exception, name, metaData, severity) {
    if (!exception) {
      return;
    }
    if (name && typeof name !== "string") {
      metaData = name;
      name = undefined;
    }
    if (!metaData) {
      metaData = {};
    }
    addScriptToMetaData(metaData);

    sendToBugsnag({
      name: name || exception.name,
      message: exception.message || exception.description,
      stacktrace: stacktraceFromException(exception) || generateStacktrace(),
      file: exception.fileName || exception.sourceURL,
      lineNumber: exception.lineNumber || exception.line,
      columnNumber: exception.columnNumber ? exception.columnNumber + 1 : undefined,
      severity: severity || "warning"
    }, metaData);
  };

  // #### Bugsnag.notify
  //
  // Notify Bugsnag about an error by passing in a `name` and `message`,
  // without requiring an exception.
  self.notify = function (name, message, metaData, severity) {
    sendToBugsnag({
      name: name,
      message: message,
      stacktrace: generateStacktrace(),
      // These are defaults so that 'bugsnag.notify()' calls show up in old IE,
      // newer browsers get a legit stacktrace from generateStacktrace().
      file: window.location.toString(),
      lineNumber: 1,
      severity: severity || "warning"
    }, metaData);
  };

  // Return a function acts like the given function, but reports
  // any exceptions to Bugsnag before re-throwing them.
  //
  // This is not a public function because it can only be used if
  // the exception is not caught after being thrown out of this function.
  //
  // If you call wrap twice on the same function, it'll give you back the
  // same wrapped function. This lets removeEventListener to continue to
  // work.
  function wrap(_super, options) {
    try {
      if (typeof _super !== "function") {
        return _super;
      }
      if (!_super.bugsnag) {
        var currentScript = getCurrentScript();
        _super.bugsnag = function (event) {
          if (options && options.eventHandler) {
            lastEvent = event;
          }
          lastScript = currentScript;

          // We set shouldCatch to false on IE < 10 because catching the error ruins the file/line as reported in window.onerror,
          // We set shouldCatch to false on Chrome/Safari because it interferes with "break on unhandled exception"
          // All other browsers need shouldCatch to be true, as they don't pass the exception object to window.onerror
          if (shouldCatch) {
            try {
              return _super.apply(this, arguments);
            } catch (e) {
              // We do this rather than stashing treating the error like lastEvent
              // because in FF 26 onerror is not called for synthesized event handlers.
              if (getSetting("autoNotify", true)) {
                self.notifyException(e, null, null, "error");
                ignoreNextOnError();
              }
              throw e;
            } finally {
              lastScript = null;
            }
          } else {
            var ret = _super.apply(this, arguments);
            // in case of error, this is set to null in window.onerror
            lastScript = null;
            return ret;
          }
        };
        _super.bugsnag.bugsnag = _super.bugsnag;
      }
      return _super.bugsnag;

    // This can happen if _super is not a normal javascript function.
    // For example, see https://github.com/bugsnag/bugsnag-js/issues/28
    } catch (e) {
      return _super;
    }
  }

  //
  // ### Script tag tracking
  //

  // To emulate document.currentScript we use document.scripts.last.
  // This only works while synchronous scripts are running, so we track
  // that here.
  var synchronousScriptsRunning = document.readyState !== "complete";
  function loadCompleted() {
    synchronousScriptsRunning = false;
  }

  // from jQuery. We don't have quite such tight bounds as they do if
  // we end up on the window.onload event as we don't try and hack
  // the .scrollLeft() fix in because it doesn't work in frames so
  // we'd need these fallbacks anyway.
  // The worst that can happen is we group an event handler that fires
  // before us into the last script tag.
  if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", loadCompleted, true);
    window.addEventListener("load", loadCompleted, true);
  } else {
    window.attachEvent("onload", loadCompleted);
  }

  function getCurrentScript() {
    var script = document.currentScript || lastScript;

    if (!script && synchronousScriptsRunning) {
      var scripts = document.scripts || document.getElementsByTagName("script");
      script = scripts[scripts.length - 1];
    }

    return script;
  }

  function addScriptToMetaData(metaData) {
    var script = getCurrentScript();

    if (script) {
      metaData.script = {
        src: script.src,
        content: getSetting("inlineScript", true) ? script.innerHTML : ""
      };
    }
  }

  //
  // ### Helpers & Setup
  //

  // Compile regular expressions upfront.
  var API_KEY_REGEX = /^[0-9a-f]{32}$/i;
  var FUNCTION_REGEX = /function\s*([\w\-$]+)?\s*\(/i;

  // Set up default notifier settings.
  var DEFAULT_BASE_ENDPOINT = "https://notify.bugsnag.com/";
  var DEFAULT_NOTIFIER_ENDPOINT = DEFAULT_BASE_ENDPOINT + "js";
  var NOTIFIER_VERSION = "2.5.0";

  // Keep a reference to the currently executing script in the DOM.
  // We'll use this later to extract settings from attributes.
  var scripts = document.getElementsByTagName("script");
  var thisScript = scripts[scripts.length - 1];

  // Simple logging function that wraps `console.log` if available.
  // This is useful for warning about configuration issues
  // eg. forgetting to set an API key.
  function log(msg) {
    var disableLog = getSetting("disableLog");

    var console = window.console;
    if (console !== undefined && console.log !== undefined && !disableLog) {
      console.log("[Bugsnag] " + msg);
    }
  }

  // Deeply serialize an object into a query string. We use the PHP-style
  // nested object syntax, `nested[keys]=val`, to support heirachical
  // objects. Similar to jQuery's `$.param` method.
  function serialize(obj, prefix, depth) {
    var maxDepth = getSetting("maxDepth", maxPayloadDepth);

    if (depth >= maxDepth) {
      return encodeURIComponent(prefix) + "=[RECURSIVE]";
    }
    depth = depth + 1 || 1;

    try {
      if (window.Node && obj instanceof window.Node) {
        return encodeURIComponent(prefix) + "=" + encodeURIComponent(targetToString(obj));
      }

      var str = [];
      for (var p in obj) {
        if (obj.hasOwnProperty(p) && p != null && obj[p] != null) {
          var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
          str.push(typeof v === "object" ? serialize(v, k, depth) : encodeURIComponent(k) + "=" + encodeURIComponent(v));
        }
      }
      return str.join("&");
    } catch (e) {
      return encodeURIComponent(prefix) + "=" + encodeURIComponent("" + e);
    }
  }

  // Deep-merge the `source` object into the `target` object and return
  // the `target`. Properties in source that will overwrite those in target.
  // Similar to jQuery's `$.extend` method.
  function merge(target, source, depth) {
    if (source == null) {
      return target;
    } else if (depth >= getSetting("maxDepth", maxPayloadDepth)) {
      return "[RECURSIVE]";
    }

    target = target || {};
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        try {
          if (source[key].constructor === Object) {
            target[key] = merge(target[key], source[key], depth + 1 || 1);
          } else {
            target[key] = source[key];
          }
        } catch (e) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }

  // Make a HTTP request with given `url` and `params` object.
  // For maximum browser compatibility and cross-domain support, requests are
  // made by creating a temporary JavaScript `Image` object.
  // Additionally the request can be done via XHR (needed for Chrome apps and extensions)
  // To set the script to use XHR, you can specify data-notifyhandler attribute in the script tag
  // Eg. `<script data-notifyhandler="xhr">` - the request defaults to image if attribute is not set
  function request(url, params) {
    url += "?" + serialize(params) + "&ct=img&cb=" + new Date().getTime();
    if (typeof BUGSNAG_TESTING !== "undefined" && self.testRequest) {
      self.testRequest(url, params);
    } else {
      var notifyHandler = getSetting("notifyHandler");
      if (notifyHandler === "xhr") {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.send();
      } else {
        var img = new Image();
        img.src = url;
      }
    }
  }

  // Extract all `data-*` attributes from a DOM element and return them as an
  // object. This is used to allow Bugsnag settings to be set via attributes
  // on the `script` tag, eg. `<script data-apikey="xyz">`.
  // Similar to jQuery's `$(el).data()` method.
  function getData(node) {
    var dataAttrs = {};
    var dataRegex = /^data\-([\w\-]+)$/;

    // If the node doesn't exist due to being loaded as a commonjs module,
    // then return an empty object and fallback to self[].
    if (node) {
      var attrs = node.attributes;
      for (var i = 0; i < attrs.length; i++) {
        var attr = attrs[i];
        if (dataRegex.test(attr.nodeName)) {
          var key = attr.nodeName.match(dataRegex)[1];
          dataAttrs[key] = attr.value || attr.nodeValue;
        }
      }
    }

    return dataAttrs;
  }

  // Get configuration settings from either `self` (the `Bugsnag` object)
  // or `data` (the `data-*` attributes).
  var data;
  function getSetting(name, fallback) {
    data = data || getData(thisScript);
    var setting = self[name] !== undefined ? self[name] : data[name.toLowerCase()];
    if (setting === "false") {
      setting = false;
    }
    return setting !== undefined ? setting : fallback;
  }

  // Validate a Bugsnag API key exists and is of the correct format.
  function validateApiKey(apiKey) {
    if (!apiKey || !apiKey.match(API_KEY_REGEX)) {
      log("Invalid API key '" + apiKey + "'");
      return false;
    }

    return true;
  }

  // Send an error to Bugsnag.
  function sendToBugsnag(details, metaData) {
    // Validate the configured API key.
    var apiKey = getSetting("apiKey");
    if (!validateApiKey(apiKey) || !eventsRemaining) {
      return;
    }
    eventsRemaining -= 1;

    // Check if we should notify for this release stage.
    var releaseStage = getSetting("releaseStage", "production");
    var notifyReleaseStages = getSetting("notifyReleaseStages");
    if (notifyReleaseStages) {
      var shouldNotify = false;
      for (var i = 0; i < notifyReleaseStages.length; i++) {
        if (releaseStage === notifyReleaseStages[i]) {
          shouldNotify = true;
          break;
        }
      }

      if (!shouldNotify) {
        return;
      }
    }

    // Don't send multiple copies of the same error.
    // This fixes a problem when a client goes into an infinite loop,
    // and starts wasting all their bandwidth sending messages to bugsnag.
    var deduplicate = [details.name, details.message, details.stacktrace].join("|");
    if (deduplicate === previousNotification) {
      return;
    } else {
      previousNotification = deduplicate;
    }

    if (lastEvent) {
      metaData = metaData || {};
      metaData["Last Event"] = eventToMetaData(lastEvent);
    }

    // Build the request payload by combining error information with other data
    // such as user-agent and locale, `metaData` and settings.
    var payload = {
      notifierVersion: NOTIFIER_VERSION,

      apiKey: apiKey,
      projectRoot: getSetting("projectRoot") || window.location.protocol + "//" + window.location.host,
      context: getSetting("context") || window.location.pathname,
      userId: getSetting("userId"), // Deprecated, remove in v3
      user: getSetting("user"),
      metaData: merge(merge({}, getSetting("metaData")), metaData),
      releaseStage: releaseStage,
      appVersion: getSetting("appVersion"),

      url: window.location.href,
      userAgent: navigator.userAgent,
      language: navigator.language || navigator.userLanguage,

      severity: details.severity,

      name: details.name,
      message: details.message,
      stacktrace: details.stacktrace,
      file: details.file,
      lineNumber: details.lineNumber,
      columnNumber: details.columnNumber,
      payloadVersion: "2"
    };

    // Run any `beforeNotify` function
    var beforeNotify = self.beforeNotify;
    if (typeof(beforeNotify) === "function") {
      var retVal = beforeNotify(payload, payload.metaData);
      if (retVal === false) {
        return;
      }
    }

    if (payload.lineNumber === 0 && (/Script error\.?/).test(payload.message)) {
      return log("Ignoring cross-domain script error. See https://bugsnag.com/docs/notifiers/js/cors");
    }

    // Make the HTTP request
    request(getSetting("endpoint") || DEFAULT_NOTIFIER_ENDPOINT, payload);
  }

  // Generate a browser stacktrace (or approximation) from the current stack.
  // This is used to add a stacktrace to `Bugsnag.notify` calls, and to add a
  // stacktrace approximation where we can't get one from an exception.
  function generateStacktrace() {
    var generated, stacktrace;
    var MAX_FAKE_STACK_SIZE = 10;
    var ANONYMOUS_FUNCTION_PLACEHOLDER = "[anonymous]";

    // Try to generate a real stacktrace (most browsers, except IE9 and below).
    try {
      throw new Error("");
    } catch (exception) {
      generated = "<generated>\n";
      stacktrace = stacktraceFromException(exception);
    }

    // Otherwise, build a fake stacktrace from the list of method names by
    // looping through the list of functions that called this one (and skip
    // whoever called us).
    if (!stacktrace) {
      generated = "<generated-ie>\n";
      var functionStack = [];
      try {
        var curr = arguments.callee.caller.caller;
        while (curr && functionStack.length < MAX_FAKE_STACK_SIZE) {
          var fn = FUNCTION_REGEX.test(curr.toString()) ? RegExp.$1 || ANONYMOUS_FUNCTION_PLACEHOLDER : ANONYMOUS_FUNCTION_PLACEHOLDER;
          functionStack.push(fn);
          curr = curr.caller;
        }
      } catch (e) {
        log(e);
      }
      stacktrace = functionStack.join("\n");
    }

    // Tell the backend to ignore the first two lines in the stack-trace.
    // generateStacktrace() + window.onerror,
    // generateStacktrace() + notify,
    // generateStacktrace() + notifyException
    return generated + stacktrace;
  }

  // Get the stacktrace string from an exception
  function stacktraceFromException(exception) {
    return exception.stack || exception.backtrace || exception.stacktrace;
  }

  // Populate the event tab of meta-data.
  function eventToMetaData(event) {
    var tab = {
      millisecondsAgo: new Date() - event.timeStamp,
      type: event.type,
      which: event.which,
      target: targetToString(event.target)
    };

    return tab;
  }

  // Convert a DOM element into a string suitable for passing to Bugsnag.
  function targetToString(target) {
    if (target) {
      var attrs = target.attributes;

      if (attrs) {
        var ret = "<" + target.nodeName.toLowerCase();
        for (var i = 0; i < attrs.length; i++) {
          if (attrs[i].value && attrs[i].value.toString() !== "null") {
            ret += " " + attrs[i].name + "=\"" + attrs[i].value + "\"";
          }
        }
        return ret + ">";
      } else {
         // e.g. #document
        return target.nodeName;
      }
    }
  }

  // If we've notified bugsnag of an exception in wrap, we don't want to
  // re-notify when it hits window.onerror after we re-throw it.
  function ignoreNextOnError() {
    ignoreOnError += 1;
    window.setTimeout(function () {
      ignoreOnError -= 1;
    });
  }

  // Disable catching on IE < 10 as it destroys stack-traces from generateStackTrace()
  if (!window.atob) {
    shouldCatch = false;

  // Disable catching on browsers that support HTML5 ErrorEvents properly.
  // This lets debug on unhandled exceptions work.
  } else if (window.ErrorEvent) {
    try {
      if (new window.ErrorEvent("test").colno === 0) {
        shouldCatch = false;
      }
    } catch(e){ /* No action needed */ }
  }


  //
  // ### Polyfilling
  //

  // Add a polyFill to an object
  function polyFill(obj, name, makeReplacement) {
    var original = obj[name];
    var replacement = makeReplacement(original);
    obj[name] = replacement;

    if (typeof BUGSNAG_TESTING !== "undefined" && window.undo) {
      window.undo.push(function () {
        obj[name] = original;
      });
    }
  }

  if (getSetting("autoNotify", true)) {
    //
    // ### Automatic error notification
    //
    // Attach to `window.onerror` events and notify Bugsnag when they happen.
    // These are mostly js compile/parse errors, but on some browsers all
    // "uncaught" exceptions will fire this event.
    //
    polyFill(window, "onerror", function (_super) {
      // Keep a reference to any existing `window.onerror` handler
      if (typeof BUGSNAG_TESTING !== "undefined") {
        self._onerror = _super;
      }

      return function bugsnag(message, url, lineNo, charNo, exception) {
        var shouldNotify = getSetting("autoNotify", true);
        var metaData = {};

        // IE 6+ support.
        if (!charNo && window.event) {
          charNo = window.event.errorCharacter;
        }

        addScriptToMetaData(metaData);
        lastScript = null;

        if (shouldNotify && !ignoreOnError) {

          sendToBugsnag({
            name: exception && exception.name || "window.onerror",
            message: message,
            file: url,
            lineNumber: lineNo,
            columnNumber: charNo,
            stacktrace: (exception && stacktraceFromException(exception)) || generateStacktrace(),
            severity: "error"
          }, metaData);
        }

        if (typeof BUGSNAG_TESTING !== "undefined") {
          _super = self._onerror;
        }

        // Fire the existing `window.onerror` handler, if one exists
        if (_super) {
          _super(message, url, lineNo, charNo, exception);
        }
      };
    });

    var hijackTimeFunc = function (_super) {
      // Note, we don't do `_super.call` because that doesn't work on IE 8,
      // luckily this is implicitly window so it just works everywhere.
      //
      // setTimout in all browsers except IE <9 allows additional parameters
      // to be passed, so in order to support these without resorting to call/apply
      // we need an extra layer of wrapping.
      return function (f, t) {
        if (typeof f === "function") {
          f = wrap(f);
          var args = Array.prototype.slice.call(arguments, 2);
          return _super(function () {
            f.apply(this, args);
          }, t);
        } else {
          return _super(f, t);
        }
      };
    };

    polyFill(window, "setTimeout", hijackTimeFunc);
    polyFill(window, "setInterval", hijackTimeFunc);

    if (window.requestAnimationFrame) {
      polyFill(window, "requestAnimationFrame", function (_super) {
        return function (callback) {
          return _super(wrap(callback));
        };
      });
    }

    if (window.setImmediate) {
      polyFill(window, "setImmediate", function (_super) {
        return function () {
          var args = Array.prototype.slice.call(arguments);
          args[0] = wrap(args[0]);
          return _super.apply(this, args);
        };
      });
    }

    // EventTarget is all that's required in modern chrome/opera
    // EventTarget + Window + ModalWindow is all that's required in modern FF (there are a few Moz prefixed ones that we're ignoring)
    // The rest is a collection of stuff for Safari and IE 11. (Again ignoring a few MS and WebKit prefixed things)
    "EventTarget Window Node ApplicationCache AudioTrackList ChannelMergerNode CryptoOperation EventSource FileReader HTMLUnknownElement IDBDatabase IDBRequest IDBTransaction KeyOperation MediaController MessagePort ModalWindow Notification SVGElementInstance Screen TextTrack TextTrackCue TextTrackList WebSocket WebSocketWorker Worker XMLHttpRequest XMLHttpRequestEventTarget XMLHttpRequestUpload".replace(/\w+/g, function (global) {
      var prototype = window[global] && window[global].prototype;
      if (prototype && prototype.hasOwnProperty && prototype.hasOwnProperty("addEventListener")) {
        polyFill(prototype, "addEventListener", function (_super) {
          return function (e, f, capture, secure) {
            // HTML lets event-handlers be objects with a handlEvent function,
            // we need to change f.handleEvent here, as self.wrap will ignore f.
            try {
              if (f && f.handleEvent) {
                f.handleEvent = wrap(f.handleEvent, {eventHandler: true});
              }
            } catch (err) {
              // When selenium is installed, we sometimes get 'Permission denied to access property "handleEvent"'
              // Because this catch is around Bugsnag library code, it won't catch any user errors
              log(err);
            }
            return _super.call(this, e, wrap(f, {eventHandler: true}), capture, secure);
          };
        });

        // We also need to hack removeEventListener so that you can remove any
        // event listeners.
        polyFill(prototype, "removeEventListener", function (_super) {
          return function (e, f, capture, secure) {
            _super.call(this, e, f, capture, secure);
            return _super.call(this, e, wrap(f), capture, secure);
          };
        });
      }
    });
  }

  window.Bugsnag = self;
  // If people are using a javascript loader, we should integrate with it.
  // We don't want to defer instrumenting their code with callbacks however,
  // so we slightly abuse the intent and continue with our plan of polyfilling
  // the browser whether or not they ever actually require the module.
  // This has the nice side-effect of continuing to work when people are using
  // AMD but loading Bugsnag via a CDN.
  // It has the not-so-nice side-effect of polluting the global namespace, but
  // you can easily call Bugsnag.noConflict() to fix that.
  if (typeof define === "function" && define.amd) {
    // AMD
    define([], function () {
      return self;
    });
  } else if (typeof module === "object" && typeof module.exports === "object") {
    // CommonJS/Browserify
    module.exports = self;
  }

})(window, window.Bugsnag);

},{}],6:[function(require,module,exports){
require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

},{"../../modules/_core":12,"../../modules/es6.object.define-property":41}],7:[function(require,module,exports){
require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;

},{"../../modules/_core":12,"../../modules/es6.object.keys":42}],8:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],9:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":25}],10:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":34,"./_to-iobject":36,"./_to-length":37}],11:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],12:[function(require,module,exports){
var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],13:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":8}],14:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],15:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":19}],16:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":20,"./_is-object":25}],17:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],18:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var has = require('./_has');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":12,"./_ctx":13,"./_global":20,"./_has":21,"./_hide":22}],19:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],20:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],21:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],22:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":15,"./_object-dp":27,"./_property-desc":31}],23:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":15,"./_dom-create":16,"./_fails":19}],24:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":11}],25:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],26:[function(require,module,exports){
module.exports = true;

},{}],27:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":9,"./_descriptors":15,"./_ie8-dom-define":23,"./_to-primitive":39}],28:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":10,"./_has":21,"./_shared-key":32,"./_to-iobject":36}],29:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":17,"./_object-keys-internal":28}],30:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export');
var core = require('./_core');
var fails = require('./_fails');
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"./_core":12,"./_export":18,"./_fails":19}],31:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],32:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":33,"./_uid":40}],33:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":12,"./_global":20,"./_library":26}],34:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":35}],35:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],36:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":14,"./_iobject":24}],37:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":35}],38:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":14}],39:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":25}],40:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],41:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });

},{"./_descriptors":15,"./_export":18,"./_object-dp":27}],42:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object');
var $keys = require('./_object-keys');

require('./_object-sap')('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

},{"./_object-keys":29,"./_object-sap":30,"./_to-object":38}],43:[function(require,module,exports){
(function (process,global){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
 * @version   2.3.0
 */

(function() {
    "use strict";
    function lib$es6$promise$utils$$objectOrFunction(x) {
      return typeof x === 'function' || (typeof x === 'object' && x !== null);
    }

    function lib$es6$promise$utils$$isFunction(x) {
      return typeof x === 'function';
    }

    function lib$es6$promise$utils$$isMaybeThenable(x) {
      return typeof x === 'object' && x !== null;
    }

    var lib$es6$promise$utils$$_isArray;
    if (!Array.isArray) {
      lib$es6$promise$utils$$_isArray = function (x) {
        return Object.prototype.toString.call(x) === '[object Array]';
      };
    } else {
      lib$es6$promise$utils$$_isArray = Array.isArray;
    }

    var lib$es6$promise$utils$$isArray = lib$es6$promise$utils$$_isArray;
    var lib$es6$promise$asap$$len = 0;
    var lib$es6$promise$asap$$toString = {}.toString;
    var lib$es6$promise$asap$$vertxNext;
    var lib$es6$promise$asap$$customSchedulerFn;

    var lib$es6$promise$asap$$asap = function asap(callback, arg) {
      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len] = callback;
      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len + 1] = arg;
      lib$es6$promise$asap$$len += 2;
      if (lib$es6$promise$asap$$len === 2) {
        // If len is 2, that means that we need to schedule an async flush.
        // If additional callbacks are queued before the queue is flushed, they
        // will be processed by this flush that we are scheduling.
        if (lib$es6$promise$asap$$customSchedulerFn) {
          lib$es6$promise$asap$$customSchedulerFn(lib$es6$promise$asap$$flush);
        } else {
          lib$es6$promise$asap$$scheduleFlush();
        }
      }
    }

    function lib$es6$promise$asap$$setScheduler(scheduleFn) {
      lib$es6$promise$asap$$customSchedulerFn = scheduleFn;
    }

    function lib$es6$promise$asap$$setAsap(asapFn) {
      lib$es6$promise$asap$$asap = asapFn;
    }

    var lib$es6$promise$asap$$browserWindow = (typeof window !== 'undefined') ? window : undefined;
    var lib$es6$promise$asap$$browserGlobal = lib$es6$promise$asap$$browserWindow || {};
    var lib$es6$promise$asap$$BrowserMutationObserver = lib$es6$promise$asap$$browserGlobal.MutationObserver || lib$es6$promise$asap$$browserGlobal.WebKitMutationObserver;
    var lib$es6$promise$asap$$isNode = typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

    // test for web worker but not in IE10
    var lib$es6$promise$asap$$isWorker = typeof Uint8ClampedArray !== 'undefined' &&
      typeof importScripts !== 'undefined' &&
      typeof MessageChannel !== 'undefined';

    // node
    function lib$es6$promise$asap$$useNextTick() {
      var nextTick = process.nextTick;
      // node version 0.10.x displays a deprecation warning when nextTick is used recursively
      // setImmediate should be used instead instead
      var version = process.versions.node.match(/^(?:(\d+)\.)?(?:(\d+)\.)?(\*|\d+)$/);
      if (Array.isArray(version) && version[1] === '0' && version[2] === '10') {
        nextTick = setImmediate;
      }
      return function() {
        nextTick(lib$es6$promise$asap$$flush);
      };
    }

    // vertx
    function lib$es6$promise$asap$$useVertxTimer() {
      return function() {
        lib$es6$promise$asap$$vertxNext(lib$es6$promise$asap$$flush);
      };
    }

    function lib$es6$promise$asap$$useMutationObserver() {
      var iterations = 0;
      var observer = new lib$es6$promise$asap$$BrowserMutationObserver(lib$es6$promise$asap$$flush);
      var node = document.createTextNode('');
      observer.observe(node, { characterData: true });

      return function() {
        node.data = (iterations = ++iterations % 2);
      };
    }

    // web worker
    function lib$es6$promise$asap$$useMessageChannel() {
      var channel = new MessageChannel();
      channel.port1.onmessage = lib$es6$promise$asap$$flush;
      return function () {
        channel.port2.postMessage(0);
      };
    }

    function lib$es6$promise$asap$$useSetTimeout() {
      return function() {
        setTimeout(lib$es6$promise$asap$$flush, 1);
      };
    }

    var lib$es6$promise$asap$$queue = new Array(1000);
    function lib$es6$promise$asap$$flush() {
      for (var i = 0; i < lib$es6$promise$asap$$len; i+=2) {
        var callback = lib$es6$promise$asap$$queue[i];
        var arg = lib$es6$promise$asap$$queue[i+1];

        callback(arg);

        lib$es6$promise$asap$$queue[i] = undefined;
        lib$es6$promise$asap$$queue[i+1] = undefined;
      }

      lib$es6$promise$asap$$len = 0;
    }

    function lib$es6$promise$asap$$attemptVertex() {
      try {
        var r = require;
        var vertx = r('vertx');
        lib$es6$promise$asap$$vertxNext = vertx.runOnLoop || vertx.runOnContext;
        return lib$es6$promise$asap$$useVertxTimer();
      } catch(e) {
        return lib$es6$promise$asap$$useSetTimeout();
      }
    }

    var lib$es6$promise$asap$$scheduleFlush;
    // Decide what async method to use to triggering processing of queued callbacks:
    if (lib$es6$promise$asap$$isNode) {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useNextTick();
    } else if (lib$es6$promise$asap$$BrowserMutationObserver) {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMutationObserver();
    } else if (lib$es6$promise$asap$$isWorker) {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMessageChannel();
    } else if (lib$es6$promise$asap$$browserWindow === undefined && typeof require === 'function') {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$attemptVertex();
    } else {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useSetTimeout();
    }

    function lib$es6$promise$$internal$$noop() {}

    var lib$es6$promise$$internal$$PENDING   = void 0;
    var lib$es6$promise$$internal$$FULFILLED = 1;
    var lib$es6$promise$$internal$$REJECTED  = 2;

    var lib$es6$promise$$internal$$GET_THEN_ERROR = new lib$es6$promise$$internal$$ErrorObject();

    function lib$es6$promise$$internal$$selfFullfillment() {
      return new TypeError("You cannot resolve a promise with itself");
    }

    function lib$es6$promise$$internal$$cannotReturnOwn() {
      return new TypeError('A promises callback cannot return that same promise.');
    }

    function lib$es6$promise$$internal$$getThen(promise) {
      try {
        return promise.then;
      } catch(error) {
        lib$es6$promise$$internal$$GET_THEN_ERROR.error = error;
        return lib$es6$promise$$internal$$GET_THEN_ERROR;
      }
    }

    function lib$es6$promise$$internal$$tryThen(then, value, fulfillmentHandler, rejectionHandler) {
      try {
        then.call(value, fulfillmentHandler, rejectionHandler);
      } catch(e) {
        return e;
      }
    }

    function lib$es6$promise$$internal$$handleForeignThenable(promise, thenable, then) {
       lib$es6$promise$asap$$asap(function(promise) {
        var sealed = false;
        var error = lib$es6$promise$$internal$$tryThen(then, thenable, function(value) {
          if (sealed) { return; }
          sealed = true;
          if (thenable !== value) {
            lib$es6$promise$$internal$$resolve(promise, value);
          } else {
            lib$es6$promise$$internal$$fulfill(promise, value);
          }
        }, function(reason) {
          if (sealed) { return; }
          sealed = true;

          lib$es6$promise$$internal$$reject(promise, reason);
        }, 'Settle: ' + (promise._label || ' unknown promise'));

        if (!sealed && error) {
          sealed = true;
          lib$es6$promise$$internal$$reject(promise, error);
        }
      }, promise);
    }

    function lib$es6$promise$$internal$$handleOwnThenable(promise, thenable) {
      if (thenable._state === lib$es6$promise$$internal$$FULFILLED) {
        lib$es6$promise$$internal$$fulfill(promise, thenable._result);
      } else if (thenable._state === lib$es6$promise$$internal$$REJECTED) {
        lib$es6$promise$$internal$$reject(promise, thenable._result);
      } else {
        lib$es6$promise$$internal$$subscribe(thenable, undefined, function(value) {
          lib$es6$promise$$internal$$resolve(promise, value);
        }, function(reason) {
          lib$es6$promise$$internal$$reject(promise, reason);
        });
      }
    }

    function lib$es6$promise$$internal$$handleMaybeThenable(promise, maybeThenable) {
      if (maybeThenable.constructor === promise.constructor) {
        lib$es6$promise$$internal$$handleOwnThenable(promise, maybeThenable);
      } else {
        var then = lib$es6$promise$$internal$$getThen(maybeThenable);

        if (then === lib$es6$promise$$internal$$GET_THEN_ERROR) {
          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$GET_THEN_ERROR.error);
        } else if (then === undefined) {
          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
        } else if (lib$es6$promise$utils$$isFunction(then)) {
          lib$es6$promise$$internal$$handleForeignThenable(promise, maybeThenable, then);
        } else {
          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
        }
      }
    }

    function lib$es6$promise$$internal$$resolve(promise, value) {
      if (promise === value) {
        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$selfFullfillment());
      } else if (lib$es6$promise$utils$$objectOrFunction(value)) {
        lib$es6$promise$$internal$$handleMaybeThenable(promise, value);
      } else {
        lib$es6$promise$$internal$$fulfill(promise, value);
      }
    }

    function lib$es6$promise$$internal$$publishRejection(promise) {
      if (promise._onerror) {
        promise._onerror(promise._result);
      }

      lib$es6$promise$$internal$$publish(promise);
    }

    function lib$es6$promise$$internal$$fulfill(promise, value) {
      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }

      promise._result = value;
      promise._state = lib$es6$promise$$internal$$FULFILLED;

      if (promise._subscribers.length !== 0) {
        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, promise);
      }
    }

    function lib$es6$promise$$internal$$reject(promise, reason) {
      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }
      promise._state = lib$es6$promise$$internal$$REJECTED;
      promise._result = reason;

      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publishRejection, promise);
    }

    function lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection) {
      var subscribers = parent._subscribers;
      var length = subscribers.length;

      parent._onerror = null;

      subscribers[length] = child;
      subscribers[length + lib$es6$promise$$internal$$FULFILLED] = onFulfillment;
      subscribers[length + lib$es6$promise$$internal$$REJECTED]  = onRejection;

      if (length === 0 && parent._state) {
        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, parent);
      }
    }

    function lib$es6$promise$$internal$$publish(promise) {
      var subscribers = promise._subscribers;
      var settled = promise._state;

      if (subscribers.length === 0) { return; }

      var child, callback, detail = promise._result;

      for (var i = 0; i < subscribers.length; i += 3) {
        child = subscribers[i];
        callback = subscribers[i + settled];

        if (child) {
          lib$es6$promise$$internal$$invokeCallback(settled, child, callback, detail);
        } else {
          callback(detail);
        }
      }

      promise._subscribers.length = 0;
    }

    function lib$es6$promise$$internal$$ErrorObject() {
      this.error = null;
    }

    var lib$es6$promise$$internal$$TRY_CATCH_ERROR = new lib$es6$promise$$internal$$ErrorObject();

    function lib$es6$promise$$internal$$tryCatch(callback, detail) {
      try {
        return callback(detail);
      } catch(e) {
        lib$es6$promise$$internal$$TRY_CATCH_ERROR.error = e;
        return lib$es6$promise$$internal$$TRY_CATCH_ERROR;
      }
    }

    function lib$es6$promise$$internal$$invokeCallback(settled, promise, callback, detail) {
      var hasCallback = lib$es6$promise$utils$$isFunction(callback),
          value, error, succeeded, failed;

      if (hasCallback) {
        value = lib$es6$promise$$internal$$tryCatch(callback, detail);

        if (value === lib$es6$promise$$internal$$TRY_CATCH_ERROR) {
          failed = true;
          error = value.error;
          value = null;
        } else {
          succeeded = true;
        }

        if (promise === value) {
          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$cannotReturnOwn());
          return;
        }

      } else {
        value = detail;
        succeeded = true;
      }

      if (promise._state !== lib$es6$promise$$internal$$PENDING) {
        // noop
      } else if (hasCallback && succeeded) {
        lib$es6$promise$$internal$$resolve(promise, value);
      } else if (failed) {
        lib$es6$promise$$internal$$reject(promise, error);
      } else if (settled === lib$es6$promise$$internal$$FULFILLED) {
        lib$es6$promise$$internal$$fulfill(promise, value);
      } else if (settled === lib$es6$promise$$internal$$REJECTED) {
        lib$es6$promise$$internal$$reject(promise, value);
      }
    }

    function lib$es6$promise$$internal$$initializePromise(promise, resolver) {
      try {
        resolver(function resolvePromise(value){
          lib$es6$promise$$internal$$resolve(promise, value);
        }, function rejectPromise(reason) {
          lib$es6$promise$$internal$$reject(promise, reason);
        });
      } catch(e) {
        lib$es6$promise$$internal$$reject(promise, e);
      }
    }

    function lib$es6$promise$enumerator$$Enumerator(Constructor, input) {
      var enumerator = this;

      enumerator._instanceConstructor = Constructor;
      enumerator.promise = new Constructor(lib$es6$promise$$internal$$noop);

      if (enumerator._validateInput(input)) {
        enumerator._input     = input;
        enumerator.length     = input.length;
        enumerator._remaining = input.length;

        enumerator._init();

        if (enumerator.length === 0) {
          lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
        } else {
          enumerator.length = enumerator.length || 0;
          enumerator._enumerate();
          if (enumerator._remaining === 0) {
            lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
          }
        }
      } else {
        lib$es6$promise$$internal$$reject(enumerator.promise, enumerator._validationError());
      }
    }

    lib$es6$promise$enumerator$$Enumerator.prototype._validateInput = function(input) {
      return lib$es6$promise$utils$$isArray(input);
    };

    lib$es6$promise$enumerator$$Enumerator.prototype._validationError = function() {
      return new Error('Array Methods must be provided an Array');
    };

    lib$es6$promise$enumerator$$Enumerator.prototype._init = function() {
      this._result = new Array(this.length);
    };

    var lib$es6$promise$enumerator$$default = lib$es6$promise$enumerator$$Enumerator;

    lib$es6$promise$enumerator$$Enumerator.prototype._enumerate = function() {
      var enumerator = this;

      var length  = enumerator.length;
      var promise = enumerator.promise;
      var input   = enumerator._input;

      for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
        enumerator._eachEntry(input[i], i);
      }
    };

    lib$es6$promise$enumerator$$Enumerator.prototype._eachEntry = function(entry, i) {
      var enumerator = this;
      var c = enumerator._instanceConstructor;

      if (lib$es6$promise$utils$$isMaybeThenable(entry)) {
        if (entry.constructor === c && entry._state !== lib$es6$promise$$internal$$PENDING) {
          entry._onerror = null;
          enumerator._settledAt(entry._state, i, entry._result);
        } else {
          enumerator._willSettleAt(c.resolve(entry), i);
        }
      } else {
        enumerator._remaining--;
        enumerator._result[i] = entry;
      }
    };

    lib$es6$promise$enumerator$$Enumerator.prototype._settledAt = function(state, i, value) {
      var enumerator = this;
      var promise = enumerator.promise;

      if (promise._state === lib$es6$promise$$internal$$PENDING) {
        enumerator._remaining--;

        if (state === lib$es6$promise$$internal$$REJECTED) {
          lib$es6$promise$$internal$$reject(promise, value);
        } else {
          enumerator._result[i] = value;
        }
      }

      if (enumerator._remaining === 0) {
        lib$es6$promise$$internal$$fulfill(promise, enumerator._result);
      }
    };

    lib$es6$promise$enumerator$$Enumerator.prototype._willSettleAt = function(promise, i) {
      var enumerator = this;

      lib$es6$promise$$internal$$subscribe(promise, undefined, function(value) {
        enumerator._settledAt(lib$es6$promise$$internal$$FULFILLED, i, value);
      }, function(reason) {
        enumerator._settledAt(lib$es6$promise$$internal$$REJECTED, i, reason);
      });
    };
    function lib$es6$promise$promise$all$$all(entries) {
      return new lib$es6$promise$enumerator$$default(this, entries).promise;
    }
    var lib$es6$promise$promise$all$$default = lib$es6$promise$promise$all$$all;
    function lib$es6$promise$promise$race$$race(entries) {
      /*jshint validthis:true */
      var Constructor = this;

      var promise = new Constructor(lib$es6$promise$$internal$$noop);

      if (!lib$es6$promise$utils$$isArray(entries)) {
        lib$es6$promise$$internal$$reject(promise, new TypeError('You must pass an array to race.'));
        return promise;
      }

      var length = entries.length;

      function onFulfillment(value) {
        lib$es6$promise$$internal$$resolve(promise, value);
      }

      function onRejection(reason) {
        lib$es6$promise$$internal$$reject(promise, reason);
      }

      for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
        lib$es6$promise$$internal$$subscribe(Constructor.resolve(entries[i]), undefined, onFulfillment, onRejection);
      }

      return promise;
    }
    var lib$es6$promise$promise$race$$default = lib$es6$promise$promise$race$$race;
    function lib$es6$promise$promise$resolve$$resolve(object) {
      /*jshint validthis:true */
      var Constructor = this;

      if (object && typeof object === 'object' && object.constructor === Constructor) {
        return object;
      }

      var promise = new Constructor(lib$es6$promise$$internal$$noop);
      lib$es6$promise$$internal$$resolve(promise, object);
      return promise;
    }
    var lib$es6$promise$promise$resolve$$default = lib$es6$promise$promise$resolve$$resolve;
    function lib$es6$promise$promise$reject$$reject(reason) {
      /*jshint validthis:true */
      var Constructor = this;
      var promise = new Constructor(lib$es6$promise$$internal$$noop);
      lib$es6$promise$$internal$$reject(promise, reason);
      return promise;
    }
    var lib$es6$promise$promise$reject$$default = lib$es6$promise$promise$reject$$reject;

    var lib$es6$promise$promise$$counter = 0;

    function lib$es6$promise$promise$$needsResolver() {
      throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
    }

    function lib$es6$promise$promise$$needsNew() {
      throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }

    var lib$es6$promise$promise$$default = lib$es6$promise$promise$$Promise;
    /**
      Promise objects represent the eventual result of an asynchronous operation. The
      primary way of interacting with a promise is through its `then` method, which
      registers callbacks to receive either a promise's eventual value or the reason
      why the promise cannot be fulfilled.

      Terminology
      -----------

      - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
      - `thenable` is an object or function that defines a `then` method.
      - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
      - `exception` is a value that is thrown using the throw statement.
      - `reason` is a value that indicates why a promise was rejected.
      - `settled` the final resting state of a promise, fulfilled or rejected.

      A promise can be in one of three states: pending, fulfilled, or rejected.

      Promises that are fulfilled have a fulfillment value and are in the fulfilled
      state.  Promises that are rejected have a rejection reason and are in the
      rejected state.  A fulfillment value is never a thenable.

      Promises can also be said to *resolve* a value.  If this value is also a
      promise, then the original promise's settled state will match the value's
      settled state.  So a promise that *resolves* a promise that rejects will
      itself reject, and a promise that *resolves* a promise that fulfills will
      itself fulfill.


      Basic Usage:
      ------------

      ```js
      var promise = new Promise(function(resolve, reject) {
        // on success
        resolve(value);

        // on failure
        reject(reason);
      });

      promise.then(function(value) {
        // on fulfillment
      }, function(reason) {
        // on rejection
      });
      ```

      Advanced Usage:
      ---------------

      Promises shine when abstracting away asynchronous interactions such as
      `XMLHttpRequest`s.

      ```js
      function getJSON(url) {
        return new Promise(function(resolve, reject){
          var xhr = new XMLHttpRequest();

          xhr.open('GET', url);
          xhr.onreadystatechange = handler;
          xhr.responseType = 'json';
          xhr.setRequestHeader('Accept', 'application/json');
          xhr.send();

          function handler() {
            if (this.readyState === this.DONE) {
              if (this.status === 200) {
                resolve(this.response);
              } else {
                reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
              }
            }
          };
        });
      }

      getJSON('/posts.json').then(function(json) {
        // on fulfillment
      }, function(reason) {
        // on rejection
      });
      ```

      Unlike callbacks, promises are great composable primitives.

      ```js
      Promise.all([
        getJSON('/posts'),
        getJSON('/comments')
      ]).then(function(values){
        values[0] // => postsJSON
        values[1] // => commentsJSON

        return values;
      });
      ```

      @class Promise
      @param {function} resolver
      Useful for tooling.
      @constructor
    */
    function lib$es6$promise$promise$$Promise(resolver) {
      this._id = lib$es6$promise$promise$$counter++;
      this._state = undefined;
      this._result = undefined;
      this._subscribers = [];

      if (lib$es6$promise$$internal$$noop !== resolver) {
        if (!lib$es6$promise$utils$$isFunction(resolver)) {
          lib$es6$promise$promise$$needsResolver();
        }

        if (!(this instanceof lib$es6$promise$promise$$Promise)) {
          lib$es6$promise$promise$$needsNew();
        }

        lib$es6$promise$$internal$$initializePromise(this, resolver);
      }
    }

    lib$es6$promise$promise$$Promise.all = lib$es6$promise$promise$all$$default;
    lib$es6$promise$promise$$Promise.race = lib$es6$promise$promise$race$$default;
    lib$es6$promise$promise$$Promise.resolve = lib$es6$promise$promise$resolve$$default;
    lib$es6$promise$promise$$Promise.reject = lib$es6$promise$promise$reject$$default;
    lib$es6$promise$promise$$Promise._setScheduler = lib$es6$promise$asap$$setScheduler;
    lib$es6$promise$promise$$Promise._setAsap = lib$es6$promise$asap$$setAsap;
    lib$es6$promise$promise$$Promise._asap = lib$es6$promise$asap$$asap;

    lib$es6$promise$promise$$Promise.prototype = {
      constructor: lib$es6$promise$promise$$Promise,

    /**
      The primary way of interacting with a promise is through its `then` method,
      which registers callbacks to receive either a promise's eventual value or the
      reason why the promise cannot be fulfilled.

      ```js
      findUser().then(function(user){
        // user is available
      }, function(reason){
        // user is unavailable, and you are given the reason why
      });
      ```

      Chaining
      --------

      The return value of `then` is itself a promise.  This second, 'downstream'
      promise is resolved with the return value of the first promise's fulfillment
      or rejection handler, or rejected if the handler throws an exception.

      ```js
      findUser().then(function (user) {
        return user.name;
      }, function (reason) {
        return 'default name';
      }).then(function (userName) {
        // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
        // will be `'default name'`
      });

      findUser().then(function (user) {
        throw new Error('Found user, but still unhappy');
      }, function (reason) {
        throw new Error('`findUser` rejected and we're unhappy');
      }).then(function (value) {
        // never reached
      }, function (reason) {
        // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
        // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
      });
      ```
      If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.

      ```js
      findUser().then(function (user) {
        throw new PedagogicalException('Upstream error');
      }).then(function (value) {
        // never reached
      }).then(function (value) {
        // never reached
      }, function (reason) {
        // The `PedgagocialException` is propagated all the way down to here
      });
      ```

      Assimilation
      ------------

      Sometimes the value you want to propagate to a downstream promise can only be
      retrieved asynchronously. This can be achieved by returning a promise in the
      fulfillment or rejection handler. The downstream promise will then be pending
      until the returned promise is settled. This is called *assimilation*.

      ```js
      findUser().then(function (user) {
        return findCommentsByAuthor(user);
      }).then(function (comments) {
        // The user's comments are now available
      });
      ```

      If the assimliated promise rejects, then the downstream promise will also reject.

      ```js
      findUser().then(function (user) {
        return findCommentsByAuthor(user);
      }).then(function (comments) {
        // If `findCommentsByAuthor` fulfills, we'll have the value here
      }, function (reason) {
        // If `findCommentsByAuthor` rejects, we'll have the reason here
      });
      ```

      Simple Example
      --------------

      Synchronous Example

      ```javascript
      var result;

      try {
        result = findResult();
        // success
      } catch(reason) {
        // failure
      }
      ```

      Errback Example

      ```js
      findResult(function(result, err){
        if (err) {
          // failure
        } else {
          // success
        }
      });
      ```

      Promise Example;

      ```javascript
      findResult().then(function(result){
        // success
      }, function(reason){
        // failure
      });
      ```

      Advanced Example
      --------------

      Synchronous Example

      ```javascript
      var author, books;

      try {
        author = findAuthor();
        books  = findBooksByAuthor(author);
        // success
      } catch(reason) {
        // failure
      }
      ```

      Errback Example

      ```js

      function foundBooks(books) {

      }

      function failure(reason) {

      }

      findAuthor(function(author, err){
        if (err) {
          failure(err);
          // failure
        } else {
          try {
            findBoooksByAuthor(author, function(books, err) {
              if (err) {
                failure(err);
              } else {
                try {
                  foundBooks(books);
                } catch(reason) {
                  failure(reason);
                }
              }
            });
          } catch(error) {
            failure(err);
          }
          // success
        }
      });
      ```

      Promise Example;

      ```javascript
      findAuthor().
        then(findBooksByAuthor).
        then(function(books){
          // found books
      }).catch(function(reason){
        // something went wrong
      });
      ```

      @method then
      @param {Function} onFulfilled
      @param {Function} onRejected
      Useful for tooling.
      @return {Promise}
    */
      then: function(onFulfillment, onRejection) {
        var parent = this;
        var state = parent._state;

        if (state === lib$es6$promise$$internal$$FULFILLED && !onFulfillment || state === lib$es6$promise$$internal$$REJECTED && !onRejection) {
          return this;
        }

        var child = new this.constructor(lib$es6$promise$$internal$$noop);
        var result = parent._result;

        if (state) {
          var callback = arguments[state - 1];
          lib$es6$promise$asap$$asap(function(){
            lib$es6$promise$$internal$$invokeCallback(state, child, callback, result);
          });
        } else {
          lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection);
        }

        return child;
      },

    /**
      `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
      as the catch block of a try/catch statement.

      ```js
      function findAuthor(){
        throw new Error('couldn't find that author');
      }

      // synchronous
      try {
        findAuthor();
      } catch(reason) {
        // something went wrong
      }

      // async with promises
      findAuthor().catch(function(reason){
        // something went wrong
      });
      ```

      @method catch
      @param {Function} onRejection
      Useful for tooling.
      @return {Promise}
    */
      'catch': function(onRejection) {
        return this.then(null, onRejection);
      }
    };
    function lib$es6$promise$polyfill$$polyfill() {
      var local;

      if (typeof global !== 'undefined') {
          local = global;
      } else if (typeof self !== 'undefined') {
          local = self;
      } else {
          try {
              local = Function('return this')();
          } catch (e) {
              throw new Error('polyfill failed because global object is unavailable in this environment');
          }
      }

      var P = local.Promise;

      if (P && Object.prototype.toString.call(P.resolve()) === '[object Promise]' && !P.cast) {
        return;
      }

      local.Promise = lib$es6$promise$promise$$default;
    }
    var lib$es6$promise$polyfill$$default = lib$es6$promise$polyfill$$polyfill;

    var lib$es6$promise$umd$$ES6Promise = {
      'Promise': lib$es6$promise$promise$$default,
      'polyfill': lib$es6$promise$polyfill$$default
    };

    /* global define:true module:true window: true */
    if (typeof define === 'function' && define['amd']) {
      define(function() { return lib$es6$promise$umd$$ES6Promise; });
    } else if (typeof module !== 'undefined' && module['exports']) {
      module['exports'] = lib$es6$promise$umd$$ES6Promise;
    } else if (typeof this !== 'undefined') {
      this['ES6Promise'] = lib$es6$promise$umd$$ES6Promise;
    }

    lib$es6$promise$polyfill$$default();
}).call(this);


}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":47}],44:[function(require,module,exports){
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

},{}],45:[function(require,module,exports){
(function (global){
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],46:[function(require,module,exports){
!function(){"use strict";if("undefined"!=typeof window){var t=window.navigator.userAgent.match(/Edge\/(\d{2})\./),n=!!t&&16<=parseInt(t[1],10);if(!("objectFit"in document.documentElement.style!=!1)||n){var o=function(t,e,i){var n,o,l,a,d;if((i=i.split(" ")).length<2&&(i[1]=i[0]),"x"===t)n=i[0],o=i[1],l="left",a="right",d=e.clientWidth;else{if("y"!==t)return;n=i[1],o=i[0],l="top",a="bottom",d=e.clientHeight}if(n!==l&&o!==l){if(n!==a&&o!==a)return"center"===n||"50%"===n?(e.style[l]="50%",void(e.style["margin-"+l]=d/-2+"px")):void(0<=n.indexOf("%")?(n=parseInt(n))<50?(e.style[l]=n+"%",e.style["margin-"+l]=d*(n/-100)+"px"):(n=100-n,e.style[a]=n+"%",e.style["margin-"+a]=d*(n/-100)+"px"):e.style[l]=n);e.style[a]="0"}else e.style[l]="0"},l=function(t){var e=t.dataset?t.dataset.objectFit:t.getAttribute("data-object-fit"),i=t.dataset?t.dataset.objectPosition:t.getAttribute("data-object-position");e=e||"cover",i=i||"50% 50%";var n=t.parentNode;return function(t){var e=window.getComputedStyle(t,null),i=e.getPropertyValue("position"),n=e.getPropertyValue("overflow"),o=e.getPropertyValue("display");i&&"static"!==i||(t.style.position="relative"),"hidden"!==n&&(t.style.overflow="hidden"),o&&"inline"!==o||(t.style.display="block"),0===t.clientHeight&&(t.style.height="100%"),-1===t.className.indexOf("object-fit-polyfill")&&(t.className=t.className+" object-fit-polyfill")}(n),function(t){var e=window.getComputedStyle(t,null),i={"max-width":"none","max-height":"none","min-width":"0px","min-height":"0px",top:"auto",right:"auto",bottom:"auto",left:"auto","margin-top":"0px","margin-right":"0px","margin-bottom":"0px","margin-left":"0px"};for(var n in i)e.getPropertyValue(n)!==i[n]&&(t.style[n]=i[n])}(t),t.style.position="absolute",t.style.width="auto",t.style.height="auto","scale-down"===e&&(e=t.clientWidth<n.clientWidth&&t.clientHeight<n.clientHeight?"none":"contain"),"none"===e?(o("x",t,i),void o("y",t,i)):"fill"===e?(t.style.width="100%",t.style.height="100%",o("x",t,i),void o("y",t,i)):(t.style.height="100%",void("cover"===e&&t.clientWidth>n.clientWidth||"contain"===e&&t.clientWidth<n.clientWidth?(t.style.top="0",t.style.marginTop="0",o("x",t,i)):(t.style.width="100%",t.style.height="auto",t.style.left="0",t.style.marginLeft="0",o("y",t,i))))},e=function(t){if(void 0===t||t instanceof Event)t=document.querySelectorAll("[data-object-fit]");else if(t&&t.nodeName)t=[t];else{if("object"!=typeof t||!t.length||!t[0].nodeName)return!1;t=t}for(var e=0;e<t.length;e++)if(t[e].nodeName){var i=t[e].nodeName.toLowerCase();if("img"===i){if(n)continue;t[e].complete?l(t[e]):t[e].addEventListener("load",function(){l(this)})}else"video"===i?0<t[e].readyState?l(t[e]):t[e].addEventListener("loadedmetadata",function(){l(this)}):l(t[e])}return!0};"loading"===document.readyState?document.addEventListener("DOMContentLoaded",e):e(),window.addEventListener("resize",e),window.objectFitPolyfill=e}else window.objectFitPolyfill=function(){return!1}}}();
},{}],47:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],48:[function(require,module,exports){
/**
@module
@alias transition
*/
(function(window, document){
    "use strict";

    var getComputedStyle = window.getComputedStyle;
    var isTransition = "data-ttfaInTransition";

    var elements = [];
    var data = [];

    // Transition detecting
    var transitionProp = false;
    var transitionEnd = false;
    var testStyle = document.createElement("a").style;
    var testProp;

    if(testStyle[testProp = "webkitTransition"] !== undefined) {
        transitionProp = testProp;
        transitionEnd = testProp + "End";
    }

    if(testStyle[testProp = "transition"] !== undefined) {
        transitionProp = testProp;
        transitionEnd = testProp + "end";
    }

    function process(options, data) {
        var el = options.element;
        var val = options.val;
        var prop = options.prop;
        var style = el.style;
        var startVal;
        var autoVal;

        if(!transitionProp) {
            return style[prop] = val;
        }

        if(el.hasAttribute(isTransition)) {
            el.removeEventListener(transitionEnd, data.l);
        } else {
            style[transitionProp] = "none";

            startVal = getComputedStyle(el)[prop];
            style[prop] = "auto";
            autoVal = getComputedStyle(el)[prop];

            // Interrupt
            if(startVal === val || val === "auto" && startVal === autoVal) {
                return;
            }

            data.auto = autoVal;
            el.setAttribute(isTransition, 1);

            // Transition
            style[prop] = startVal;
            el.offsetWidth;
            style[transitionProp] = options.style;
        }

        style[prop] = val === "auto" ? data.auto : val;

        data.l = function (e) {
            if(e.propertyName === prop) {
                el.removeAttribute(isTransition);
                el.removeEventListener(transitionEnd, data.l);
                if(val === "auto") {
                    /* avoid transition flashes in Safari */
                    style[transitionProp] = "none";
                    style[prop] = val;
                }
            }
        };

        el.addEventListener(transitionEnd, data.l);
    }

    /**
    @param options {Object}
    @param options.element {string | element} - The DOM element or selector to transition
    @param options.val {string} - The value you want to transition to
    @param [options.prop] {string} - The CSS property to transition, defaults to `"height"`
    @param [options.style] {string} - The desired value for the `transition` CSS property (e.g. `"height 1s"`). If specified, this value is added inline and will override your CSS. Leave this value blank if you already have it defined in your stylesheet. 
    @alias module:transition-to-from-auto
    */
    function transition(options){
        var element = options.element;
        var datum;
        var index;

        if(typeof element === "string") {
            element = document.querySelector(element);
        }

        element = options.element = element instanceof Node ? element : false;
        options.prop = options.prop || "height";
        options.style = options.style || "";

        if(element) {
            index = elements.indexOf(element);
            if(~index) {
                datum = data[index];
            } else {
                datum = {};
                elements.push(element);
                data.push(datum);
            }

            process(options, datum);
        }
    }

    /**
    The name of the vendor-specific transition CSS property
    @type {string} 
    @example
    el.style[transition.prop + 'Duration'] = '1s';
    */
    transition.prop = transitionProp;

    /**
    * The name of the [transition end event](https://developer.mozilla.org/en-US/docs/Web/Events/transitionend) in the current browser (typically `"transitionend"` or `"webkitTransitionEnd"`)
    * @type {string} 
    * @example
    * el.addEventListener(transition.end, function(){
    *     // the transition ended..
    * });
    */
    transition.end = transitionEnd;


    if (typeof module === "object" && module.exports){
        module.exports = transition;
    } else if (typeof define === "function" && define.amd){
        define(function(){
            return transition;
        });
    } else {
        window.transition = transition;
    }
})(window, document);

},{}],49:[function(require,module,exports){
module.exports={
    "version": "3.13.0"
}
},{}],50:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

require('objectFitPolyfill');

var _LayoutHelper = require('./utils/LayoutHelper');

var _LayoutHelper2 = _interopRequireDefault(_LayoutHelper);

var _BugsnagHandler = require('./helpers/BugsnagHandler');

var _BugsnagHandler2 = _interopRequireDefault(_BugsnagHandler);

var _PolyfillsHandler = require('./helpers/PolyfillsHandler');

var _PolyfillsHandler2 = _interopRequireDefault(_PolyfillsHandler);

var _DropDownField = require('./components/DropDownField');

var _DropDownField2 = _interopRequireDefault(_DropDownField);

var _ExhibitionsPastFilter = require('./components/ExhibitionsPastFilter');

var _ExhibitionsPastFilter2 = _interopRequireDefault(_ExhibitionsPastFilter);

var _FullscreenBackgroundToggler = require('./components/FullscreenBackgroundToggler');

var _FullscreenBackgroundToggler2 = _interopRequireDefault(_FullscreenBackgroundToggler);

var _LandingPageTeasersExpander = require('./components/LandingPageTeasersExpander');

var _LandingPageTeasersExpander2 = _interopRequireDefault(_LandingPageTeasersExpander);

var _ImageGalleryCarousel = require('./components/ImageGalleryCarousel');

var _ImageGalleryCarousel2 = _interopRequireDefault(_ImageGalleryCarousel);

var _ImageGalleryGrid = require('./components/ImageGalleryGrid');

var _ImageGalleryGrid2 = _interopRequireDefault(_ImageGalleryGrid);

var _MenuItemActivator = require('./components/MenuItemActivator');

var _MenuItemActivator2 = _interopRequireDefault(_MenuItemActivator);

var _MobileNavigation = require('./components/MobileNavigation');

var _MobileNavigation2 = _interopRequireDefault(_MobileNavigation);

var _ModalWindowsHandler = require('./components/ModalWindowsHandler');

var _ModalWindowsHandler2 = _interopRequireDefault(_ModalWindowsHandler);

var _ProductsFilter = require('./components/ProductsFilter');

var _ProductsFilter2 = _interopRequireDefault(_ProductsFilter);

var _SearchResultsPage = require('./components/SearchResultsPage');

var _SearchResultsPage2 = _interopRequireDefault(_SearchResultsPage);

var _ArtistsFilter = require('./components/ArtistsFilter');

var _ArtistsFilter2 = _interopRequireDefault(_ArtistsFilter);

var _ExpandableText = require('./components/ExpandableText');

var _ExpandableText2 = _interopRequireDefault(_ExpandableText);

var _IntroVideoModal = require('./components/IntroVideoModal');

var _IntroVideoModal2 = _interopRequireDefault(_IntroVideoModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = function () {
    function App() {
        (0, _classCallCheck3.default)(this, App);
    }

    (0, _createClass3.default)(App, [{
        key: 'construct',
        value: function construct() {
            this.super.apply(this, arguments);
        }
    }, {
        key: 'run',
        value: function run() {

            _BugsnagHandler2.default.init();
            _PolyfillsHandler2.default.init();

            var menuItemActivator = new _MenuItemActivator2.default();
            menuItemActivator.init();

            var mobileNavigation = new _MobileNavigation2.default();
            mobileNavigation.init();

            switch (document.body.getAttribute('data-page')) {
                case 'home':
                    this.home();
                    break;
                case 'artists-index':
                    this.artistIndex();
                    break;
                case 'artist-detail':
                    this.artistDetailPages();
                    break;
                case 'exhibitions-past':
                    this.exhibitionsPast();
                    break;
                case 'exhibition-detail':
                    this.exhibitionDetailPages();
                    break;
                case 'art-fair-detail':
                    this.exhibitionDetailPages();
                    break;
                case 'products-index':
                    this.productsIndex();
                    break;
                case 'product-detail':
                    this.productDetail();
                    break;
                case 'search-results':
                    this.searchResults();
                    break;
                case 'news-index':
                    this.newsIndex();
                    break;
                case 'gallery-about':
                case 'gallery-contact':
                    this.galleryAbout();
                    break;

                default:
                    break;
            }
        }
    }, {
        key: 'home',
        value: function home() {
            var fullscreenBackgroundToggler = new _FullscreenBackgroundToggler2.default();
            fullscreenBackgroundToggler.init();

            var landingPageTeasersExpander = new _LandingPageTeasersExpander2.default();
            landingPageTeasersExpander.init();

            var introVideoModal = new _IntroVideoModal2.default();
            introVideoModal.init();
        }
    }, {
        key: 'artistIndex',
        value: function artistIndex() {
            var fullscreenBackgroundToggler = new _FullscreenBackgroundToggler2.default();
            fullscreenBackgroundToggler.init();

            var artistsFilter = new _ArtistsFilter2.default();
            artistsFilter.init();
        }
    }, {
        key: 'artistDetailPages',
        value: function artistDetailPages() {
            var modalWindowsHandler = new _ModalWindowsHandler2.default();
            modalWindowsHandler.init();
            modalWindowsHandler.initShareLinks();

            $('.expandable-text').each(function (i, item) {
                var expandableText = new _ExpandableText2.default(item);
                expandableText.init();
            });

            $('.gallery-grid').each(function (i, item) {
                var gallery = new _ImageGalleryGrid2.default($(item));
                gallery.init();
            });
        }
    }, {
        key: 'exhibitionsPast',
        value: function exhibitionsPast() {
            var exhibitionsPastFilter = new _ExhibitionsPastFilter2.default();
            exhibitionsPastFilter.init();
        }
    }, {
        key: 'exhibitionDetailPages',
        value: function exhibitionDetailPages() {

            $('.gallery-grid').each(function (i, item) {
                var gallery = new _ImageGalleryGrid2.default($(item));
                gallery.init();
            });

            var modalWindowsHandler = new _ModalWindowsHandler2.default();
            modalWindowsHandler.init();
            modalWindowsHandler.initShareLinks();
        }
    }, {
        key: 'productsIndex',
        value: function productsIndex() {
            var productsFilter = new _ProductsFilter2.default();
            productsFilter.init();
            _LayoutHelper2.default.alignColumnHeights($('.item-featured-product__pane-left'), $('.item-featured-product__pane-right'), true);
        }
    }, {
        key: 'productDetail',
        value: function productDetail() {
            var gallery = new _ImageGalleryCarousel2.default($('#gallery-carousel--products'));
            gallery.init();

            var quantityDropdown = new _DropDownField2.default($('#dropdown--buy-quantity'), function (val) {
                var $addToCartLink = $('#link-add-to-cart');
                $addToCartLink.attr('data-item-quantity', val);
            });
            quantityDropdown.init();
        }
    }, {
        key: 'searchResults',
        value: function searchResults() {
            var searchResultsPage = new _SearchResultsPage2.default();
            searchResultsPage.init();
        }
    }, {
        key: 'newsIndex',
        value: function newsIndex() {}
    }, {
        key: 'galleryAbout',
        value: function galleryAbout() {

            $('.google-maps').click(function () {
                $('.google-maps iframe').css("pointer-events", "auto");
            });

            $(".google-maps").mouseleave(function () {
                $('.google-maps iframe').css("pointer-events", "none");
            });
        }
    }]);
    return App;
}();

exports.default = App;


var app = new App();

$(document).ready(function () {
    app.run();
});

},{"./components/ArtistsFilter":51,"./components/DropDownField":52,"./components/ExhibitionsPastFilter":53,"./components/ExpandableText":54,"./components/FullscreenBackgroundToggler":55,"./components/ImageGalleryCarousel":56,"./components/ImageGalleryGrid":57,"./components/IntroVideoModal":59,"./components/LandingPageTeasersExpander":60,"./components/MenuItemActivator":61,"./components/MobileNavigation":62,"./components/ModalWindowsHandler":63,"./components/ProductsFilter":66,"./components/SearchResultsPage":67,"./helpers/BugsnagHandler":69,"./helpers/PolyfillsHandler":70,"./utils/LayoutHelper":72,"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4,"objectFitPolyfill":46}],51:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Used to filter artists between "Represented" and "Works By"
 */
var ArtistsFilter = function () {
    function ArtistsFilter() {
        (0, _classCallCheck3.default)(this, ArtistsFilter);
    }

    /**
    * Add filter buttons and events
    */


    (0, _createClass3.default)(ArtistsFilter, [{
        key: 'init',
        value: function init() {

            this.$btnArtistsRepresented = $('#btn-filter-artists-represented');
            this.$btnArtistsWorksBy = $('#btn-filter-artists-works-by');

            this.$listArtistsRepresented = $('#list-artists-represented');
            this.$listArtistsWorksBy = $('#list-artists-works-by');

            var self = this;

            this.$btnArtistsRepresented.click(function (e) {
                self.$listArtistsRepresented.show();
                self.$listArtistsWorksBy.hide();
                self.$btnArtistsRepresented.addClass('navigation__item--active');
                self.$btnArtistsWorksBy.removeClass('navigation__item--active');
            });

            this.$btnArtistsWorksBy.click(function (e) {
                self.$listArtistsWorksBy.show();
                self.$listArtistsRepresented.hide();
                self.$btnArtistsWorksBy.addClass('navigation__item--active');
                self.$btnArtistsRepresented.removeClass('navigation__item--active');
            });
        }
    }]);
    return ArtistsFilter;
}();

exports.default = ArtistsFilter;

},{"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],52:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Custom drop down field because HTML default <select> field is ugly
 */
var DropDownField = function () {
    function DropDownField(el, onChangeCallback) {
        (0, _classCallCheck3.default)(this, DropDownField);

        this.$dropdown = el;
        this.$selectedItem = el.find('.dropdown__item-selected');
        this.$items = el.find('.dropdown__list__item');
        this.onChangeCallback = onChangeCallback;
    }

    (0, _createClass3.default)(DropDownField, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.$selectedItem.click(function (e) {
                e.stopPropagation();
                $('.dropdown').not(_this.$dropdown).removeClass('dropdown--open');
                _this.$dropdown.toggleClass('dropdown--open');
            });

            this.$items.click(function (e) {
                e.stopPropagation();
                var newItem = $(e.target);
                _this.$selectedItem.attr('data-selected-value', newItem.data('value'));
                _this.$selectedItem.html(newItem.html());
                _this.$dropdown.removeClass('dropdown--open');

                // Call a callback after value changed
                if (_this.onChangeCallback) {
                    _this.onChangeCallback(newItem.data('value'));
                }
            });

            $(document).click(function (e) {
                _this.$dropdown.removeClass('dropdown--open');
            });
        }
    }]);
    return DropDownField;
}();

exports.default = DropDownField;

},{"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],53:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _UrlHelper = require('../utils/UrlHelper');

var _UrlHelper2 = _interopRequireDefault(_UrlHelper);

var _DropDownField = require('./DropDownField');

var _DropDownField2 = _interopRequireDefault(_DropDownField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Filter to filter past exhibitions
 */

var ExhibitionsPastFilter = function () {
    function ExhibitionsPastFilter() {
        (0, _classCallCheck3.default)(this, ExhibitionsPastFilter);

        this.filterArtistId = null;
        this.filterYear = null;
    }

    (0, _createClass3.default)(ExhibitionsPastFilter, [{
        key: 'init',
        value: function init() {
            var _this = this;

            // When artist filter changed (callback func)
            var artistChanged = function artistChanged(newVal) {
                if (newVal < 0) {
                    _this.filterArtistId = null;
                } else {
                    _this.filterArtistId = newVal;
                }
                _this.loadFilteredEntries();
            };

            // when year changed (callback fuc)
            var yearChanged = function yearChanged(newVal) {
                if (newVal < 0) {
                    _this.filterYear = null;
                } else {
                    _this.filterYear = newVal;
                }
                _this.loadFilteredEntries();
            };

            // Init filter fields
            var artistDropdown = new _DropDownField2.default($('#dropdown--filter-artists'), artistChanged);
            artistDropdown.init();

            var yearDropdown = new _DropDownField2.default($('#dropdown--filter-years'), yearChanged);
            yearDropdown.init();
        }

        /**
         * When a value changed
         */

    }, {
        key: 'loadFilteredEntries',
        value: function loadFilteredEntries() {

            // Activate loading spinner
            $('.loading-spinner').removeClass('hideable--hidden');

            // Get AJAX url and attach filter criteria
            var filteredExhibitionsUrl = _UrlHelper2.default.updateQueryString('filterArtistId', this.filterArtistId, '/ajax/filteredExhibitions/past');
            filteredExhibitionsUrl = _UrlHelper2.default.updateQueryString('filterYear', this.filterYear, filteredExhibitionsUrl);

            // Load the data and append it to the exhibition list
            $('#list-exhibitions-past').load(filteredExhibitionsUrl, function () {
                // When done, hide the loading spinner
                $('.loading-spinner').addClass('hideable--hidden');
            });
        }
    }]);
    return ExhibitionsPastFilter;
}();

exports.default = ExhibitionsPastFilter;

},{"../utils/UrlHelper":73,"./DropDownField":52,"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],54:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _transitionToFromAuto = require('transition-to-from-auto');

var _transitionToFromAuto2 = _interopRequireDefault(_transitionToFromAuto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
var ExpandableText = function () {
    function ExpandableText(item) {
        (0, _classCallCheck3.default)(this, ExpandableText);

        this.item = item;
        this.isOpen = false;
    }

    (0, _createClass3.default)(ExpandableText, [{
        key: 'init',
        value: function init() {
            var _this = this;

            var container = this.item.querySelector('.expandable-text__container');
            var button = this.item.querySelector('.expandable-text__show-more');
            var fade = this.item.querySelector('.expandable-text__container__fade');

            $(button).click(function () {
                (0, _transitionToFromAuto2.default)({
                    element: container,
                    prop: "height",
                    style: "height 0.4s ease-in-out",
                    val: "auto"
                });

                (0, _transitionToFromAuto2.default)({
                    element: button,
                    prop: "height",
                    style: "height 0.4s ease-in-out",
                    val: "0px"
                });

                $(fade).hide();

                _this.isOpen = true;
            });
        }
    }]);
    return ExpandableText;
}();

exports.default = ExpandableText;

},{"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4,"transition-to-from-auto":48}],55:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash.debounce');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Used to display fullscreen background images on hover (for index and artist index page)
 */
var FullscreenBackgroundToggler = function () {
    function FullscreenBackgroundToggler() {
        (0, _classCallCheck3.default)(this, FullscreenBackgroundToggler);
    }

    /**
     * Add mousemove eventlisteners
     */


    (0, _createClass3.default)(FullscreenBackgroundToggler, [{
        key: 'init',
        value: function init() {
            this.$imageTogglers = $('.item-fullscreen-bg-toggler');
            this.$fullscreenBackground = $('#fullscreen-background');

            var self = this;

            // On hover, hide UI elements and show background image
            this.$imageTogglers.mouseenter((0, _lodash2.default)(function () {

                if (!window.disableFullScreenToggler && window.innerWidth > 1024) {
                    var $item = $(this);
                    var backgroundImageUrl = $item.data('backgroundImage');

                    if (backgroundImageUrl) {
                        $('.logo-main-container').addClass('hideable--hidden');
                        $('.navigation--artists-filter').addClass('hideable--hidden');
                        $('.header-page').addClass('hideable--hidden');
                        $('.footer-page').addClass('hideable--hidden');
                        $('.btn-expand-teasers').addClass('hideable--hidden');
                        self.$imageTogglers.addClass('hideable--hidden');
                        $item.removeClass('hideable--hidden');

                        self.$fullscreenBackground.css('background-image', 'url(' + backgroundImageUrl + ')');
                        self.$fullscreenBackground.addClass('fullscreen-background--visible');
                    }
                }
            }, 200, { leading: true }));

            // On mouse leave, restore everything
            this.$imageTogglers.mouseleave((0, _lodash2.default)(function () {

                self.$imageTogglers.removeClass('hideable--hidden');
                self.$fullscreenBackground.removeClass('fullscreen-background--visible');
                $('.navigation--artists-filter').removeClass('hideable--hidden');
                $('.logo-main-container').removeClass('hideable--hidden');
                $('.header-page').removeClass('hideable--hidden');
                $('.footer-page').removeClass('hideable--hidden');
                $('.btn-expand-teasers').removeClass('hideable--hidden');
            }, 200, { leading: true }));
        }
    }]);
    return FullscreenBackgroundToggler;
}();

exports.default = FullscreenBackgroundToggler;

},{"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4,"lodash.debounce":45}],56:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Carousel Header Image Slider to show different images
 */

var ImageGalleryCarousel = function () {
    function ImageGalleryCarousel(el) {
        (0, _classCallCheck3.default)(this, ImageGalleryCarousel);

        this.$placeholder = el;
        this.$figures = this.$placeholder.find('.gallery-carousel__figure');
        this.$arrowLeft = this.$placeholder.find('.gallery-carousel__button--left');
        this.$arrowRight = this.$placeholder.find('.gallery-carousel__button--right');
    }

    (0, _createClass3.default)(ImageGalleryCarousel, [{
        key: 'init',
        value: function init() {
            var _this = this;

            // When arrow left clicked, go to last
            if (this.$arrowLeft.length) {
                this.$arrowLeft.click(function () {
                    var $currentImage = _this.$placeholder.find('.gallery-carousel__figure').not('.inactive');
                    _this.switchImage($currentImage, 'left');
                });
            }

            // When arrow right clicked, go to next
            if (this.$arrowRight.length) {
                this.$arrowRight.click(function () {
                    var $currentImage = _this.$placeholder.find('.gallery-carousel__figure').not('.inactive');
                    _this.switchImage($currentImage, 'right');
                });
            }
        }

        /**
         * Change to next or last image
         */

    }, {
        key: 'switchImage',
        value: function switchImage($currentImage, direction) {
            var $nextImage = void 0;

            if (direction === 'right') {
                if ($currentImage.next().is('figure')) {
                    $nextImage = $currentImage.next();
                } else {
                    $nextImage = this.$figures.first();
                }
            } else {
                if ($currentImage.prev().is('figure')) {
                    $nextImage = $currentImage.prev();
                } else {
                    $nextImage = this.$figures.last();
                }
            }

            if ($nextImage) {
                $currentImage.toggleClass('inactive');
                $nextImage.toggleClass('inactive');
            }
        }
    }]);
    return ImageGalleryCarousel;
}();

exports.default = ImageGalleryCarousel;

},{"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],57:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _PhotoswipeLightbox = require('./PhotoswipeLightbox');

var _PhotoswipeLightbox2 = _interopRequireDefault(_PhotoswipeLightbox);

var _UrlHelper = require('../utils/UrlHelper');

var _UrlHelper2 = _interopRequireDefault(_UrlHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Image gallery is an image gallery that displays images with captions
 *
 * This gallery scrapes the markup for all the gallery images and opens a Photoswipe
 * lightbox to show the gallery
 */
var ImageGalleryGrid = function () {
    function ImageGalleryGrid(el) {
        (0, _classCallCheck3.default)(this, ImageGalleryGrid);

        this.$placeholder = el;
        this.galleryId = el.data('blockId');
        this.imageData = [];
    }

    (0, _createClass3.default)(ImageGalleryGrid, [{
        key: 'init',
        value: function init() {
            this.scrapePhotoswipeData(); // Get all images and their data from the markup
            this.addPhotoswipeLightBox(); // Add a lightbox and a handler to open it on click
            this.tryOpenGalleryFromUrl(); // Try to open the gallery directly from URL parameters, if there are any
        }

        /**
         * Scrapes the image gallery for its gallery images and loads them to "imageData"
         */

    }, {
        key: 'scrapePhotoswipeData',
        value: function scrapePhotoswipeData() {
            var _this = this;

            var $imageItems = this.$placeholder.find('.item-gallery');

            $imageItems.each(function (i, item) {

                var imageId = $(item).data('id');
                var title = $(item).find('figcaption').html();

                // Small thumb image
                var small = {
                    url: $(item).find('.item-gallery__small-image').attr('content'),
                    width: $(item).find('.item-gallery__small-image').data('width'),
                    height: $(item).find('.item-gallery__small-image').data('height')
                };

                // Medium sized image for mobile
                var medium = {
                    url: $(item).find('.item-gallery__medium-image').attr('content'),
                    width: $(item).find('.item-gallery__medium-image').data('width'),
                    height: $(item).find('.item-gallery__medium-image').data('height')
                };

                // Large image for desktop screens
                var large = {
                    url: $(item).find('.item-gallery__large-image').attr('content'),
                    width: $(item).find('.item-gallery__large-image').data('width'),
                    height: $(item).find('.item-gallery__large-image').data('height')
                };

                // Highres for downlaod
                var highres = {
                    url: $(item).find('.item-gallery__highres-image').attr('content'),
                    width: $(item).find('.item-gallery__highres-image').data('width'),
                    height: $(item).find('.item-gallery__highres-image').data('height')
                };

                var detailUrl = $(item).find('.item-gallery__link').attr('href');

                // If the image is an artwork
                var isArtwork = $(item).has('.item-gallery__artwork-meta').length;

                var artworkMetaData = {};

                // if yes, also load its artwork metadata
                if (isArtwork) {

                    artworkMetaData.artist = $(item).find('.item-gallery__artwork-artist').attr('content');
                    artworkMetaData.year = $(item).find('.item-gallery__artwork-year').attr('content');
                    artworkMetaData.info = $(item).find('.item-gallery__artwork-info').attr('content');

                    var sizes = $(item).find('.item-gallery__artwork-multisize-info');
                    if (sizes.length) {
                        artworkMetaData.multiSizes = [];
                        sizes.each(function (i, size) {
                            artworkMetaData.multiSizes.push({
                                sizeName: $(size).find('.item-gallery__artwork-multisize-name').attr('content'),
                                edition: $(size).find('.item-gallery__artwork-edition').attr('content'),
                                medium: $(size).find('.item-gallery__artwork-medium').attr('content'),
                                size: $(size).find('.item-gallery__artwork-size').attr('content')
                            });
                        });
                    } else {
                        artworkMetaData.edition = $(item).find('.item-gallery__artwork-edition').attr('content');
                        artworkMetaData.medium = $(item).find('.item-gallery__artwork-medium').attr('content');
                        artworkMetaData.size = $(item).find('.item-gallery__artwork-size').attr('content');
                    }
                }

                // Save scraped image
                _this.imageData.push({
                    id: imageId,
                    title: title,
                    small: small,
                    medium: medium,
                    large: large,
                    highres: highres,
                    artworkMetaData: artworkMetaData,
                    detailUrl: detailUrl
                });
            });
        }

        /**
         * Adds a Photoswipe lightbox for each image gallery with the scraped data
         */

    }, {
        key: 'addPhotoswipeLightBox',
        value: function addPhotoswipeLightBox() {
            var _this2 = this;

            var $galleryLinks = this.$placeholder.find('.item-gallery__link');

            $galleryLinks.click(function (e) {
                e.preventDefault();
                var itemGallery = $(e.currentTarget).closest('.item-gallery');
                var imageId = itemGallery.data('id');
                var imageThumbEl = itemGallery.find('.item-gallery__thumb')[0];
                var photoswipeLightbox = new _PhotoswipeLightbox2.default();
                photoswipeLightbox.openPhotoswipeFromGallery(_this2.galleryId, _this2.imageData, imageId, imageThumbEl);
            });
        }

        /**
         * If an url with image gallery params is entered directly,
         * It tries to directly open the image (direct link to images)
         */

    }, {
        key: 'tryOpenGalleryFromUrl',
        value: function tryOpenGalleryFromUrl() {

            // Get the hash params with the gallery id data
            var params = _UrlHelper2.default.getParsedHashParams();
            if (params && params.gid && params.gid == this.galleryId && params.pid) {
                var photoswipeLightbox = new _PhotoswipeLightbox2.default();
                photoswipeLightbox.openPhotoswipeFromUrl(params.gid, this.imageData, params.pid);
            }
        }
    }]);
    return ImageGalleryGrid;
}();

exports.default = ImageGalleryGrid;

},{"../utils/UrlHelper":73,"./PhotoswipeLightbox":65,"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],58:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Html Input field with callback option
 */
var InputField = function () {
    function InputField(el, onChangeCallback) {
        (0, _classCallCheck3.default)(this, InputField);

        this.$inputField = el;
        this.onChangeCallback = onChangeCallback;
    }

    (0, _createClass3.default)(InputField, [{
        key: "init",
        value: function init() {
            var _this = this;

            this.$inputField.keyup(function (e) {
                var newValue = _this.$inputField.val();

                // Currently only used for filtering and search, so we only call the callback if the value is empty (reset) or at least 3 chars long
                if (newValue.length == 0 || newValue.length >= 3) {
                    _this.onChangeCallback(newValue);
                }
            });
        }
    }]);
    return InputField;
}();

exports.default = InputField;

},{"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],59:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
var IntroVideoModal = function () {
    function IntroVideoModal() {
        (0, _classCallCheck3.default)(this, IntroVideoModal);
    }

    /**
    *
    */


    (0, _createClass3.default)(IntroVideoModal, [{
        key: 'init',
        value: function init() {
            this.closeButton = document.querySelector('.intro-video__close-button');
            this.audioButton = document.querySelector('.intro-video__audio-button');
            this.introVideoModal = document.querySelector('.intro-video');
            this.introVideo = document.querySelector('.intro-video__video');

            if (this.introVideoModal) {
                this.introVideo.addEventListener('ended', this.closeModal.bind(this));
                this.closeButton.addEventListener('click', this.closeModal.bind(this));
                this.audioButton.addEventListener('click', this.toggleMute.bind(this));
            }
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            var _this = this;

            this.introVideoModal.classList.add('intro-video--hidden');
            setTimeout(function () {
                _this.introVideoModal.parentElement.removeChild(_this.introVideoModal);
            }, 1000);
            _jsCookie2.default.set('introVideoClosed', true);
        }
    }, {
        key: 'toggleMute',
        value: function toggleMute() {
            this.introVideo.muted = !this.introVideo.muted;
            this.audioButton.classList.toggle('intro-video__audio-button--muted');
        }
    }]);
    return IntroVideoModal;
}();

exports.default = IntroVideoModal;

},{"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4,"js-cookie":44}],60:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Used to expand and show additional teaser entries on the landing page
 */
var LandingPageTeasersExpander = function () {
    function LandingPageTeasersExpander() {
        (0, _classCallCheck3.default)(this, LandingPageTeasersExpander);
    }

    (0, _createClass3.default)(LandingPageTeasersExpander, [{
        key: 'init',
        value: function init() {
            this.$expandButton = $('.btn-expand-teasers');
            this.$additionalTeasers = $('#additional-teaser-items');
            this.$listTeasers = $('.list-teasers');
            this.isOpen = false;

            var self = this;

            // On click, show additional teaser items
            this.$expandButton.click(function (e) {
                e.preventDefault();

                if (!self.isOpen) {
                    self.$expandButton.find('.text-show').hide();
                    window.disableFullScreenToggler = true;
                    self.$listTeasers.addClass('inactive');
                    self.$additionalTeasers.slideDown(function () {
                        self.$expandButton.find('.text-hide').fadeIn('slow');
                        window.disableFullScreenToggler = false;
                        self.$listTeasers.removeClass('inactive');
                    });
                    self.isOpen = true;
                } else {
                    self.$expandButton.find('.text-hide').hide();
                    window.disableFullScreenToggler = true;
                    self.$listTeasers.addClass('inactive');
                    self.$additionalTeasers.slideUp(function () {
                        self.$expandButton.find('.text-show').fadeIn('slow');
                        window.disableFullScreenToggler = false;
                        self.$listTeasers.removeClass('inactive');
                    });
                    self.isOpen = false;
                }
            });
        }
    }]);
    return LandingPageTeasersExpander;
}();

exports.default = LandingPageTeasersExpander;

},{"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],61:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Checks, which navigation items should be active (according to the url) and highlights them
 */
var MenuItemActivator = function () {
    function MenuItemActivator() {
        (0, _classCallCheck3.default)(this, MenuItemActivator);

        this.mainNav = $('#navigation-main');
        this.subNav = $('#navigation-sub');
    }

    (0, _createClass3.default)(MenuItemActivator, [{
        key: 'init',
        value: function init() {

            // Set Active Menu Item of Main Navigation
            if (this.mainNav) {
                var $menuItems = this.mainNav.find('.navigation__item');
                $menuItems.each(function (i, item) {
                    var itemUrl = $(item).data('slug');
                    var currentPath = window.location.pathname;

                    if (currentPath.indexOf(itemUrl) > -1) {
                        $(item).addClass('navigation__item--active');
                    }
                });
            }

            // Set Active Menu Item of Sub Navigation
            if (this.subNav) {
                var _$menuItems = this.subNav.find('.navigation__item');
                _$menuItems.each(function (i, item) {
                    var itemUrl = $(item).data('slug');
                    var currentPath = window.location.pathname;

                    if (currentPath.indexOf(itemUrl) > -1) {
                        $(item).addClass('navigation__item--active');
                    }
                });
            }
        }
    }]);
    return MenuItemActivator;
}();

exports.default = MenuItemActivator;

},{"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],62:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileNavigation = function () {
    function MobileNavigation() {
        (0, _classCallCheck3.default)(this, MobileNavigation);

        this.mobileNavigation = $('.mobile-overlay-nav');
        this.buttonMobileNav = $('.button-mobile-nav');
    }

    (0, _createClass3.default)(MobileNavigation, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.buttonMobileNav.click(function (e) {
                _this.mobileNavigation.toggleClass('mobile-overlay-nav--open');
                _this.buttonMobileNav.toggleClass('button-mobile-nav--open');
                $('body').toggleClass('mobile-nav-is-open');
                $('main.main').toggleClass('mobile-nav-is-open');
            });
        }
    }]);
    return MobileNavigation;
}();

exports.default = MobileNavigation;

},{"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],63:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _UrlHelper = require('../utils/UrlHelper');

var _UrlHelper2 = _interopRequireDefault(_UrlHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Opens a modal window overlay on click of a certain button
 * Handles multiple different modal windows
 */
var ModalWindowsHandler = function () {
    function ModalWindowsHandler() {
        (0, _classCallCheck3.default)(this, ModalWindowsHandler);
    }

    (0, _createClass3.default)(ModalWindowsHandler, [{
        key: 'init',
        value: function init() {
            var modalWindows = $('.modal-window');
            var modalWindowLinks = $('.modal-link');

            // Open right modal window for each link
            modalWindowLinks.each(function (i, modalLink) {
                var $modalLink = $(modalLink);
                var modalWindowId = $modalLink.data('modalWindowId');
                $modalLink.click(function () {
                    $('html').velocity('scroll', {
                        offset: '0px'
                    });
                    $('#' + modalWindowId).addClass('modal-window--visible');
                });
            });

            // Add handlers to each modal window
            modalWindows.each(function (i, modalWindow) {
                var $modalWindow = $(modalWindow);
                var closeButton = $modalWindow.find('.modal-window__close');
                closeButton.click(function () {
                    $modalWindow.removeClass('modal-window--visible');
                });
            });
        }

        /**
         * Initiales the share links for the share modal window (add popup open handlers to them)
         */

    }, {
        key: 'initShareLinks',
        value: function initShareLinks() {
            $('.share-list__link').click(function (e) {
                e.preventDefault();
                var link = e.target;
                _UrlHelper2.default.openPopup($(link).attr('href'));
            });
        }
    }]);
    return ModalWindowsHandler;
}();

exports.default = ModalWindowsHandler;

},{"../utils/UrlHelper":73,"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],64:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _UrlHelper = require('../utils/UrlHelper');

var _UrlHelper2 = _interopRequireDefault(_UrlHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The Photoswipe Caption class handles the captions part of a open photoswipe image
 * The captions contain the artwork meta and also the share links
 */
var PhotoswipeCaptions = function () {
    function PhotoswipeCaptions() {
        (0, _classCallCheck3.default)(this, PhotoswipeCaptions);
    }

    (0, _createClass3.default)(PhotoswipeCaptions, [{
        key: 'init',
        value: function init() {
            var $pswpElement = $('#photoswipe-modal');

            // Put a click handler on the caption title to open the
            // Image artwork meta and share links

            var isMobile = window.innerWidth < 1024;

            if (isMobile) {
                $pswpElement.find('.pswp__caption__title, .pswp__button--info').on('click touchend', function () {
                    $pswpElement.find('.pswp__caption__dropdown').toggleClass('pswp__caption__dropdown--visible');
                    $pswpElement.toggleClass('pswp--captions-visible');
                });

                $pswpElement.find('.pswp__caption__dropdown').on('click touchend', function () {
                    $pswpElement.find('.pswp__caption__dropdown').removeClass('pswp__caption__dropdown--visible');
                    $pswpElement.removeClass('pswp--captions-visible');
                });

                $pswpElement.find('.pswp__caption__dropdown__inner').on('click touchend', function (e) {
                    e.stopPropagation();
                });
            } else {
                $pswpElement.find('.pswp__caption__dropdown').addClass('pswp__caption__dropdown--visible');
                $pswpElement.addClass('pswp--captions-visible');
            }
        }

        /**
         * Builds the markup for the caption elements. Gets called by the
         * photoswipe gallery plugin, each time the gallery gets opened or a new image is viewed
         */

    }, {
        key: 'buildImageCaptions',
        value: function buildImageCaptions(item, captionEl, isFake) {

            // See if it is an artwork
            var isArtwork = item.artworkMetaData != undefined;

            // Set caption title (with artist or without)
            var titleCombined = isArtwork && item.artworkMetaData.artist ? item.artworkMetaData.artist + ', ' + item.title.trim() : item.title.trim();
            //$(captionEl).find('.pswp__caption__title').html(title.trim());

            // Set artwork Meta Data. Only if it is an artwork
            var $artworkMeta = $(captionEl).find('.pswp__caption__artwork-meta');
            var emailBodyMeta = '';
            $artworkMeta.html('');
            if (isArtwork) {
                if (item.artworkMetaData.artist) $artworkMeta.append(item.artworkMetaData.artist + '<br>');
                if (item.title) $artworkMeta.append(item.title.trim());
                if (item.artworkMetaData.year) $artworkMeta.append(', ' + item.artworkMetaData.year + '<br>');
                if (!item.artworkMetaData.year) $artworkMeta.append('<br>');

                if (item.artworkMetaData.multiSizes && item.artworkMetaData.multiSizes.length) {
                    item.artworkMetaData.multiSizes.forEach(function (multisize) {
                        if (multisize.sizeName) $artworkMeta.append('<br><h3>' + multisize.sizeName + '</h3>');
                        if (multisize.medium) $artworkMeta.append(multisize.medium + '<br>');
                        if (multisize.size) $artworkMeta.append(multisize.size + '<br>');
                        if (multisize.edition) $artworkMeta.append(multisize.edition + '<br>');
                    });
                } else {
                    if (item.artworkMetaData.medium) $artworkMeta.append(item.artworkMetaData.medium + '<br>');
                    if (item.artworkMetaData.size) $artworkMeta.append(item.artworkMetaData.size + '<br>');
                    if (item.artworkMetaData.edition) $artworkMeta.append(item.artworkMetaData.edition + '<br>');
                }

                emailBodyMeta = $artworkMeta.html();

                if (item.artworkMetaData.info) $artworkMeta.append('<br>' + item.artworkMetaData.info + '<br>');
            }

            // Gets the share url for all social share links
            var baseUrl = '';
            if (window.location.href.indexOf('#') > 0) {
                baseUrl = window.location.href.substr(0, window.location.href.indexOf('#'));
            } else {
                baseUrl = window.location.href;
            }

            var shareUrl = baseUrl + ('#&gid=' + this.galleryId + '&pid=' + item.id);

            // Set Link Request Link to send an Email. Only for artwork
            if (isArtwork) {
                this.addRequestEmailLink(captionEl, titleCombined, emailBodyMeta, shareUrl);
            } else {
                $(captionEl).find('.pswp__caption__link-request').hide();
            }

            // encode the Share Url
            // shareUrl = encodeURIComponent(shareUrl);

            // // Find all social sharing link elements
            // let linkFacebook = $(captionEl).find('.link-facebook');
            // let linkTwitter = $(captionEl).find('.link-twitter');
            // //let linkGooglePlus = $(captionEl).find('.link-google-plus');
            // let linkPinterest = $(captionEl).find('.link-pinterest');

            // // Create all sharing links and add them to the elements
            // linkFacebook.attr('href', `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&picture=${item.src}`);
            // linkTwitter.attr('href', `https://twitter.com/share?text=${titleCombined}&url=${shareUrl}`);
            // //linkGooglePlus.attr('href', `https://plus.google.com/share?url=${shareUrl}`);
            // linkPinterest.attr('href', `http://www.pinterest.com/pin/create/button/?url=${shareUrl}&media=${item.src}&description=${titleCombined}`);


            // Add clickhandler to all social share links to open the sharing link in a popup
            // $('.pswp__caption__share__link').click((e) => {
            //     e.preventDefault();
            //     let link = e.target;
            //     UrlHelper.openPopup($(link).attr('href'));
            // });

            if (item.highres) {
                $('.pswp__link-download').attr('href', item.highres.url);
            }

            if (item.detailUrl) {
                $('.pswp__link-single').attr('href', item.detailUrl + '-img');
            }

            return true;
        }

        /**
         * Adds the link to send an "information request". A email gets
         * created on the fly and the subject and body is already populated
         * The email data is saved in the markup and gets extracted
         */

    }, {
        key: 'addRequestEmailLink',
        value: function addRequestEmailLink(captionEl, title, emailBodyMeta, shareUrl) {
            var requestLink = $(captionEl).find('.pswp__caption__link-request');
            var informationRequestEmail = requestLink.data('informationRequestEmail');
            var informationRequestSubject = requestLink.data('informationRequestSubject');

            // Create and "style" body
            var informationRequestBody = requestLink.data('informationRequestBody') + '\n' + emailBodyMeta + '\n ' + encodeURI(shareUrl) + ' \n\n\n' + requestLink.data('informationRequestBodyTwo');
            informationRequestBody = informationRequestBody.replace(/<br>/gi, '\n');
            informationRequestBody = informationRequestBody.replace(/<br \/>/gi, '\n');
            informationRequestBody = informationRequestBody.replace(/<p>/gi, '');
            informationRequestBody = informationRequestBody.replace(/<\/p>/gi, '\n');
            informationRequestBody = informationRequestBody.replace(/<\/h3>/g, '\n');
            informationRequestBody = informationRequestBody.replace(/<(.|\n)*?>/g, '');
            informationRequestBody = encodeURIComponent(informationRequestBody);

            // Create mailto-link with encoded email content
            var requestLinkUrl = 'mailto:' + informationRequestEmail + '?subject=' + informationRequestSubject + '&body=' + informationRequestBody;

            requestLink.attr('href', requestLinkUrl);
            requestLink.show();
        }

        /**
         * Clean the captions and remove everything. Happens when switching to the next image
         * or closing the gallery (so no false info is there when opened next time)
         */

    }, {
        key: 'cleanCaptions',
        value: function cleanCaptions() {
            var $pswpElement = $('#photoswipe-modal');

            // Remove click handlers
            $pswpElement.find('.pswp__caption__title').off('click');
            $pswpElement.find('.pswp__caption__share__link').off('click');
            $pswpElement.find('.pswp__button--info').off('click touchend');
            $pswpElement.find('.pswp__caption__dropdown').off('click touchend');
            $pswpElement.find('.pswp__caption__dropdown__inner').off('click touchend');

            // Close information dropdown
            $pswpElement.find('.pswp__caption__dropdown').removeClass('pswp__caption__dropdown--visible');

            // Empty fields
            $pswpElement.find('.pswp__caption__artwork-meta').html('');
            $pswpElement.find('.pswp__caption__title').html('');
            $pswpElement.find('.pswp__caption__link-request').attr('href', '');
            $pswpElement.find('.link-facebook').attr('href', '');
            $pswpElement.find('.link-twitter').attr('href', '');
            $pswpElement.find('.link-instagram').attr('href', '');
            $pswpElement.find('.link-pinterest').attr('href', '');
        }
    }]);
    return PhotoswipeCaptions;
}();

exports.default = PhotoswipeCaptions;

},{"../utils/UrlHelper":73,"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],65:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _ArrayHelper = require('../utils/ArrayHelper');

var _ArrayHelper2 = _interopRequireDefault(_ArrayHelper);

var _PhotoswipeCaptions = require('./PhotoswipeCaptions');

var _PhotoswipeCaptions2 = _interopRequireDefault(_PhotoswipeCaptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The PhotoswipeLightbox Class prepares everything to open a Photoswipe lightbox for a collection of images.
 * The Lightbox can either be opened by clicking on a item (gallery title image e.g.) or opened directly from
 * URL.
 *
 * The class gets passed all necessary information
 */
var PhotoswipeLightbox = function () {
    function PhotoswipeLightbox(el) {
        (0, _classCallCheck3.default)(this, PhotoswipeLightbox);

        this.useLargeImages = false; // init for later
        this.firstResize = true; // init for later
        this.pswpElement = $('#photoswipe-modal')[0];
        this.photoswipeCaptions = new _PhotoswipeCaptions2.default(); // Create captions and their EventHandlers
        this.photoswipeCaptions.init();
    }

    /**
     * Open Photoswipe from a gallery
     */


    (0, _createClass3.default)(PhotoswipeLightbox, [{
        key: 'openPhotoswipeFromGallery',
        value: function openPhotoswipeFromGallery(galleryId, items, itemId, thumbnailEl) {
            this._openPhotoswipeLightbox(galleryId, items, itemId, false, false, thumbnailEl);
        }

        /**
         * Opens Gallery from url. No animation is used
         */

    }, {
        key: 'openPhotoswipeFromUrl',
        value: function openPhotoswipeFromUrl(galleryId, items, itemId) {
            this._openPhotoswipeLightbox(galleryId, items, itemId, true, true, null);
        }
    }, {
        key: '_openPhotoswipeLightbox',
        value: function _openPhotoswipeLightbox(galleryId, items, itemId, fromUrl, disableAnimation, thumbnailEl) {
            var _this = this;

            // Gets the index of the title image in the gallery items. With this index, the Photoswipe opens
            // the correct image from the galleryimages -> the one that got clicked
            var index = _ArrayHelper2.default.findIndexByAttr(items, 'id', itemId);

            this.photoswipeCaptions.galleryId = galleryId;
            this.isArtwork = items && items[0].artworkMetaData != undefined && (0, _keys2.default)(items[0].artworkMetaData).length;

            // Set initial options for the Photoswipe UI
            var options = {
                history: true,
                galleryUID: galleryId, // ID of the gallery (multiple galleries per page possible)
                galleryPIDs: true,
                index: index,
                maxSpreadZoom: 1,
                shareEl: false,
                arrowEl: true,
                zoomEl: false,
                timeToIdle: 0, // Idle time until UI hides
                timeToIdleOutside: 0, // Idle time outside browserwindow until UI hides
                loadingIndicatorDelay: 1000, // Time until loading indicator gets used
                clickToCloseNonZoomable: true, // don't close non-zoomable image on click
                barsSize: {
                    top: 60,
                    bottom: 20
                },
                tapToToggleControls: false, // Dont close UI on tap
                tapToClose: true, // Close gallery on tap

                closeOnScroll: true, // Close it on scroll! They see me scrollin', they haatiin'...
                closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar', 'img'],

                // Function builds caption markup
                // So each time, a new image is loaded, this function is called
                // and the captions get built from scratch
                addCaptionHTMLFn: function addCaptionHTMLFn(item, captionEl, isFake) {
                    _this.photoswipeCaptions.buildImageCaptions(item, captionEl, isFake);
                }

            };

            // Only show animations if opened from a gallery, not when opened directly from url
            if (disableAnimation) {
                options.showAnimationDuration = 0;
            }

            // Zoom in from gallery thumbnail if opened from there (only if there is one)
            // The thumbnail image grows until it fits the big lightbox image size
            if (!fromUrl && thumbnailEl) {
                options.getThumbBoundsFn = function (index) {
                    var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                    var rect = thumbnailEl.getBoundingClientRect();
                    return {
                        x: rect.left - (_this.isArtwork ? 320 : 0), // 320 --> offset from left because  of artwork info
                        y: rect.top + pageYScroll - (_this.isArtwork ? 20 : 0), // 20 --> offset from top because  of artwork info
                        w: rect.width
                    };
                };
            }

            this.pswpElement.classList.remove('pswp--is-artwork');
            this.pswpElement.classList.remove('pswp--captions-visible');

            if (this.isArtwork) {
                this.pswpElement.classList.add('pswp--is-artwork');
            }

            // Initialize the gallery
            var gallery = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, items, options);

            // Disable Zoom functionality
            gallery.options.maxSpreadZoom = gallery.getZoomLevel();
            gallery.options.getDoubleTapZoom = function (isMouseClick, item) {
                return item.initialZoomLevel;
            };

            // Define if highres or mobile images are used and set up the right data
            this.initPhotoswipeData(gallery);

            // Init (and open) the gallery
            gallery.init();

            // Call a event handler on modal close, to clean up events and other stuff
            gallery.listen('close', function () {
                _this.onCloseGallery();
            });

            // Put a mousemove listener on the arrays to only show them when the mouse is near
            this.initHoverableArrays();
        }

        /**
         * Put a mousemove listener on the arrays to only show them when the mouse is near
         */

    }, {
        key: 'initHoverableArrays',
        value: function initHoverableArrays() {
            var arrowLeft = $(this.pswpElement).find('.pswp__button--arrow--left');
            var arrowRight = $(this.pswpElement).find('.pswp__button--arrow--right');

            // Initially hide the arrows
            arrowLeft.addClass('hideable--hidden');
            arrowRight.addClass('hideable--hidden');

            // If the mouse gets close to the arrows, (25% of the screen) they get displayed. The
            // event gets throtteled, so it's not called too often, unneccesarily (how the f... u write that word)
            $(this.pswpElement).mousemove($.throttle(100, function (e) {

                // show left arrow on approaching
                if (e.pageX < window.innerWidth / 4) {
                    if (arrowLeft.hasClass('hideable--hidden')) arrowLeft.removeClass('hideable--hidden');
                } else {
                    if (!arrowLeft.hasClass('hideable--hidden')) arrowLeft.addClass('hideable--hidden');
                }

                // show right arrow on approaching
                if (e.pageX > window.innerWidth - window.innerWidth / 4) {
                    if (arrowRight.hasClass('hideable--hidden')) arrowRight.removeClass('hideable--hidden');
                } else {
                    if (!arrowRight.hasClass('hideable--hidden')) arrowRight.addClass('hideable--hidden');
                }
            }));
        }

        /**
         * Define if highres or mobile images are used and set up the right data
         */

    }, {
        key: 'initPhotoswipeData',
        value: function initPhotoswipeData(gallery) {

            // This gets called automatically by Photoswipe when opening the gallery or resizing the window
            // beforeResize event fires each time size of gallery viewport updates
            gallery.listen('beforeResize', function () {
                // gallery.viewportSize.x - width of PhotoSwipe viewport
                // gallery.viewportSize.y - height of PhotoSwipe viewport
                // window.devicePixelRatio - ratio between physical pixels and device independent pixels (Number)
                //                          1 (regular display), 2 (@2x, retina) ...

                var realViewportWidth = 0;
                var imageSrcWillChange = false;

                // calculate real pixels when size changes
                //realViewportWidth = gallery.viewportSize.x * window.devicePixelRatio;
                realViewportWidth = gallery.viewportSize.x;

                // Find out if current images need to be changed
                if (this.useLargeImages && realViewportWidth <= 667) {
                    // Mobile Images
                    this.useLargeImages = false;
                    imageSrcWillChange = true;
                } else if (!this.useLargeImages && realViewportWidth > 667) {
                    // Big Images
                    this.useLargeImages = true;
                    imageSrcWillChange = true;
                }

                // Invalidate items only when source is changed and when it's not the first update
                if (imageSrcWillChange && !this.firstResize) {
                    // invalidateCurrItems sets a flag on slides that are in DOM,
                    // which will force update of content (image) on window.resize.
                    gallery.invalidateCurrItems();
                }

                if (this.firstResize) {
                    this.firstResize = false;
                }
            });

            // gettingData event fires each time PhotoSwipe retrieves image source & size
            // The provided gallery images array is not quite in the format, Photoswipe wants it. So
            // we save the items by the correct name and also choose responsive images
            gallery.listen('gettingData', function (index, item) {
                // Set image source & size based on real viewport width
                // Use Mobile or Highres images. Also the right item attributes
                // get set
                if (this.useLargeImages) {
                    item.src = item.large.url;
                    item.w = item.large.width;
                    item.h = item.large.height;
                } else {
                    item.src = item.medium.url;
                    item.w = item.medium.width;
                    item.h = item.medium.height;
                }

                item.pid = item.id;
                item.msrc = item.small.url; // Thumbnail src
            });
        }

        /**
         * Clean up events and other stuff when closing the gallery. Else they stack up, because
         * the same DOM container is used for all galleries
         */

    }, {
        key: 'onCloseGallery',
        value: function onCloseGallery() {

            // Remove click handlers from the caption title and empty all fields
            this.photoswipeCaptions.cleanCaptions();

            // Remove mousemove handler
            var pswpElement = $('#photoswipe-modal');
            pswpElement.off('mousemove');
        }
    }]);
    return PhotoswipeLightbox;
}();

exports.default = PhotoswipeLightbox;

},{"../utils/ArrayHelper":71,"./PhotoswipeCaptions":64,"babel-runtime/core-js/object/keys":2,"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],66:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _UrlHelper = require('../utils/UrlHelper');

var _UrlHelper2 = _interopRequireDefault(_UrlHelper);

var _DropDownField = require('./DropDownField');

var _DropDownField2 = _interopRequireDefault(_DropDownField);

var _InputField = require('./InputField');

var _InputField2 = _interopRequireDefault(_InputField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Filter to filter store products
 */
var ProductsFilter = function () {
    function ProductsFilter() {
        (0, _classCallCheck3.default)(this, ProductsFilter);

        this.filterArtistId = null;
        this.filterSearchQuery = null;
        this.delayTimer = null;
    }

    (0, _createClass3.default)(ProductsFilter, [{
        key: 'init',
        value: function init() {
            var _this = this;

            // Callback for when artist changed
            var artistChanged = function artistChanged(newVal) {
                if (newVal < 0) {
                    _this.filterArtistId = null;
                } else {
                    _this.filterArtistId = newVal;
                }
                _this.loadFilteredEntries(false);
            };

            // Callback for when searchquery changed
            var queryStringChanged = function queryStringChanged(newVal) {
                if (newVal.length == 0) {
                    _this.filterSearchQuery = null;
                } else {
                    _this.filterSearchQuery = encodeURIComponent(newVal);
                }

                _this.loadFilteredEntries(true);
            };

            // Init Dropdown and Text fields
            var artistDropdown = new _DropDownField2.default($('#dropdown--filter-artists'), artistChanged);
            artistDropdown.init();

            var queryInputField = new _InputField2.default($('#input-field--filter-search-query'), queryStringChanged);
            queryInputField.init();
        }

        /**
         * Load new, filtered products via AJAX and write them to the list container
         */

    }, {
        key: 'loadFilteredEntries',
        value: function loadFilteredEntries(delayRequest) {
            var _this2 = this;

            // Buffer the searching, by having a 500ms delay, before sending the filter request. While
            // typing, reset the delay each time to only send the filtering action when the user stopped typing
            // and is idleing for at least 500ms
            if (this.delayTimer) {
                clearTimeout(this.delayTimer);
            }

            // Delay (debounce) the filter action
            this.delayTimer = setTimeout(function () {

                // Show loading spinner
                $('.loading-spinner').removeClass('hideable--hidden');

                // Get AJAX url and attach filter criteria
                var filteredProductsUrl = _UrlHelper2.default.updateQueryString('filterArtistId', _this2.filterArtistId, '/ajax/filteredProducts');
                filteredProductsUrl = _UrlHelper2.default.updateQueryString('filterSearchQuery', _this2.filterSearchQuery, filteredProductsUrl);

                // Load the data and append it to the product list
                $('#list-products').load(filteredProductsUrl, function () {
                    // When done, hide the loading spinner
                    $('.loading-spinner').addClass('hideable--hidden');
                });
            }, delayRequest ? 500 : 0);
        }
    }]);
    return ProductsFilter;
}();

exports.default = ProductsFilter;

},{"../utils/UrlHelper":73,"./DropDownField":52,"./InputField":58,"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],67:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _UrlHelper = require('../utils/UrlHelper');

var _UrlHelper2 = _interopRequireDefault(_UrlHelper);

var _ImageGalleryGrid = require('./ImageGalleryGrid');

var _ImageGalleryGrid2 = _interopRequireDefault(_ImageGalleryGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The Search Result Page shows all search results. This class handles the search requests (per ajax) and also
 * put some eventhandlers on the results.
 */
var SearchResultsPage = function () {
    function SearchResultsPage() {
        (0, _classCallCheck3.default)(this, SearchResultsPage);
    }

    /**
     * Initializes the search result page (there are no results yet)
     */


    (0, _createClass3.default)(SearchResultsPage, [{
        key: 'init',
        value: function init() {
            var _this = this;

            var submitLink = $('#link-submit-search');

            // Also send search request when pressing Enter
            $(document).keypress(function (e) {
                if (e.which == 13) {
                    _this.startSearch();

                    // Remove focus from field
                    $('#input-field--page-search-query').blur();
                }
            });

            // Reset search results when navigating somewhere else
            $('.header-page').click(function (e) {
                localStorage.setItem('craftSearchResults', '');
            });

            // Send search request when pressing search button
            submitLink.click(function (e) {
                e.preventDefault();
                _this.startSearch();
            });

            // If there was a previous search, it got stored to localstorage
            // And we can display it again. This way, search results are not lost
            // when navigation to a found entry and then back to the search results
            var previousSearch = localStorage.getItem('craftSearchResults');
            if (previousSearch) {
                // Show the previous search results
                $('#list-search-results').html(previousSearch);
                this.prepareSearchResults(true);
            }

            // Highlight the search item in the main navigation
            var searchNaviLink = $('.search__link');
            searchNaviLink.addClass('search__link--active');
        }

        /**
         * Execute the search query
         */

    }, {
        key: 'startSearch',
        value: function startSearch() {
            var _this2 = this;

            // Get the value
            var searchQuery = $('#input-field--page-search-query').val();

            // Only start if not empty
            if (searchQuery.length >= 3) {

                // Show loading spinner
                $('.loading-spinner').removeClass('hideable--hidden');

                // Build the search AJAX url with param criteria
                var resultUrl = $('#link-submit-search').attr('href') + '/' + encodeURIComponent(searchQuery);

                // Load the search results in the result list container and execute the callback when done
                $('#list-search-results').load(resultUrl, function () {
                    _this2.onSearchResultsReturned();
                });
            }
        }

        /**
         * When done with searching,
         * remove the loading spinner, prepare the results
         * and save the search results to local storage
         */

    }, {
        key: 'onSearchResultsReturned',
        value: function onSearchResultsReturned() {

            // Hide loading spinner
            $('.loading-spinner').addClass('hideable--hidden');

            // Prepare search results
            this.prepareSearchResults(false);

            // Save to local storage to keep results when navigating to other sites
            localStorage.setItem('craftSearchResults', $('#list-search-results').html());

            var searchQuery = $('#input-field--page-search-query').val();
            $("#list-search-results").mark(searchQuery, {
                exclude: ['h2']
            });
        }

        /**
         * Prepare the search result list and add Eventhandlers, Photoswipe Lightboxes etc.
         */

    }, {
        key: 'prepareSearchResults',
        value: function prepareSearchResults(isFromPreviousLoad) {

            // Put life to the "expand button", it shows all results
            var expandResultSectionLink = $('.search-results__link-show-all');
            expandResultSectionLink.click(function (e) {
                e.preventDefault();
                var linkElement = $(e.target);
                var containerElement = linkElement.prev();
                containerElement.removeClass('search-results__item-container--hidden');
                linkElement.addClass('search-results__link-show-all--hidden');
            });

            // For artwork search results, add photoswipe lightboxes to the images
            $('.gallery-grid').each(function (i, item) {
                var gallery = new _ImageGalleryGrid2.default($(item));
                gallery.init();
            });
        }
    }]);
    return SearchResultsPage;
}();

exports.default = SearchResultsPage;

},{"../utils/UrlHelper":73,"./ImageGalleryGrid":57,"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],68:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var APP_DEBUG = exports.APP_DEBUG = window.App.constants.APP_DEBUG;
var BUGSNAG_API_KEY = exports.BUGSNAG_API_KEY = window.App.constants.BUGSNAG_API_KEY;
var BUGSNAG_NOTIFY_RELEASE_STAGES = exports.BUGSNAG_NOTIFY_RELEASE_STAGES = window.App.constants.BUGSNAG_NOTIFY_RELEASE_STAGES;

},{}],69:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _bugsnagJs = require('bugsnag-js');

var _bugsnagJs2 = _interopRequireDefault(_bugsnagJs);

var _config = require('config');

var config = _interopRequireWildcard(_config);

var _project = require('../../../../project.json');

var _project2 = _interopRequireDefault(_project);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BugsnagHandler = function () {
    function BugsnagHandler() {
        (0, _classCallCheck3.default)(this, BugsnagHandler);
    }

    (0, _createClass3.default)(BugsnagHandler, null, [{
        key: 'init',


        /**
         *
         */
        value: function init() {

            _bugsnagJs2.default.apiKey = config.BUGSNAG_API_KEY;
            _bugsnagJs2.default.releaseStage = BugsnagHandler.detectReleaseStage();
            _bugsnagJs2.default.notifyReleaseStages = config.BUGSNAG_NOTIFY_RELEASE_STAGES;
            _bugsnagJs2.default.appVersion = _project2.default.version;
        }

        /**
         *
         */

    }, {
        key: 'detectReleaseStage',
        value: function detectReleaseStage() {

            var href = window.location.href;

            return href.indexOf(".pizza") !== -1 ? "staging" : href.indexOf(".app") !== -1 || href.indexOf(".dev") !== -1 || href.indexOf(".test") !== -1 || href.indexOf("localhost") !== -1 ? "development" : "production";
        }
    }]);
    return BugsnagHandler;
}(); //
// BugsnagHandler Handler
// ---------------
//
// Initializes BugsnagHandler and adds some configuration
//

exports.default = BugsnagHandler;

},{"../../../../project.json":49,"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4,"bugsnag-js":5,"config":68}],70:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _es6Promise = require('es6-promise');

var _es6Promise2 = _interopRequireDefault(_es6Promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PolyfillsHandler = function () {
    function PolyfillsHandler() {
        (0, _classCallCheck3.default)(this, PolyfillsHandler);
    }

    (0, _createClass3.default)(PolyfillsHandler, null, [{
        key: 'init',


        /**
         *
         */
        value: function init() {
            PolyfillsHandler.addIE10Class();
            _es6Promise2.default.polyfill();
        }

        /**
         * IE10 dropped support for conditional comments. So to add "ie10" to the html tag (as ie9 & ie8 added), we
         * use this fancy hack. Only for IE10
         */

    }, {
        key: 'addIE10Class',
        value: function addIE10Class() {
            if (Function('/*@cc_on return document.documentMode===10@*/')()) {
                document.documentElement.className += ' ie10';
            }
        }
    }]);
    return PolyfillsHandler;
}();

exports.default = PolyfillsHandler;

},{"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4,"es6-promise":43}],71:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrayHelper = function () {
    function ArrayHelper() {
        (0, _classCallCheck3.default)(this, ArrayHelper);
    }

    (0, _createClass3.default)(ArrayHelper, null, [{
        key: "findIndexByAttr",


        /**
         * Gets the index of an array item, which attribute match a certain value. Returns on first hit
         */
        value: function findIndexByAttr(array, attr, value) {
            for (var i = 0; i < array.length; i += 1) {
                if (array[i][attr] == value) {
                    return i;
                }
            }
        }
    }]);
    return ArrayHelper;
}();

exports.default = ArrayHelper;

},{"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],72:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LayoutHelper = function () {
    function LayoutHelper() {
        (0, _classCallCheck3.default)(this, LayoutHelper);
    }

    (0, _createClass3.default)(LayoutHelper, null, [{
        key: "alignColumnHeights",


        /**
         * Aligns the height of a column to the height of another one.
         * Also does this on window resize
         */
        value: function alignColumnHeights(sourceCol, targetCol) {
            var fireOnWindowResize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            function alignColHeight() {
                targetCol.height(sourceCol.height());
            }

            if (fireOnWindowResize) {
                $(window).resize($.throttle(100, function () {
                    alignColHeight();
                }));
            }

            alignColHeight();
        }
    }]);
    return LayoutHelper;
}();

exports.default = LayoutHelper;

},{"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}],73:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UrlHelper = function () {
    function UrlHelper() {
        (0, _classCallCheck3.default)(this, UrlHelper);
    }

    (0, _createClass3.default)(UrlHelper, null, [{
        key: "updateQueryString",


        /**
         * Updates a parameter in a URL querystring. If the parameter is not yet there, it gets added. If it is already there,
         * the value gets updated. For example if you have an url: yourdomain.dev?searchFilter=asd&id=17, you can use
         * updateQueryString("searchFilter", "xyz", window.location.href); to replace the search filter. The other parameters stay untouched
         *
         * @param  {string} key   The parameter name to update or add
         * @param  {mixed}  value The new value
         * @param  {string} url   The whole url, e.g.: window.location.href
         * @return {string}       The updated url stirng
         */
        value: function updateQueryString(key, value, url) {
            if (!url) url = window.location.href;
            var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi");
            var hash = void 0;

            if (re.test(url)) {
                if (typeof value !== 'undefined' && value !== null) return url.replace(re, '$1' + key + "=" + value + '$2$3');else {
                    hash = url.split('#');
                    url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
                    if (typeof hash[1] !== 'undefined' && hash[1] !== null) url += '#' + hash[1];
                    return url;
                }
            } else {
                if (typeof value !== 'undefined' && value !== null) {
                    var separator = url.indexOf('?') !== -1 ? '&' : '?';
                    hash = url.split('#');
                    url = hash[0] + separator + key + '=' + value;
                    if (typeof hash[1] !== 'undefined' && hash[1] !== null) url += '#' + hash[1];
                    return url;
                } else return url;
            }
        }

        /**
         * Gets the hash params of the url and returns them as an object with attributes.
         * For example the url "yourdomain.dev#param=xy&id=7" will return an object with
         * two attributes called array.parm and array.id.
         *
         * @return {} object with all hash params
         */

    }, {
        key: "getParsedHashParams",
        value: function getParsedHashParams() {
            var hash = window.location.hash.substring(1),
                params = {};

            var vars = hash.split('&');
            for (var i = 0; i < vars.length; i++) {
                if (!vars[i]) {
                    continue;
                }
                var pair = vars[i].split('=');
                params[pair[0]] = pair[1];
            }

            return params;
        }

        /**
        * Opens the good ol' pop up window
        */

    }, {
        key: "openPopup",
        value: function openPopup(url) {
            window.open(url, 'modal-popup', 'scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=' + (window.screen ? Math.round(screen.width / 2 - 275) : 100));
        }
    }]);
    return UrlHelper;
}();

exports.default = UrlHelper;

},{"babel-runtime/helpers/classCallCheck":3,"babel-runtime/helpers/createClass":4}]},{},[50]);
